import { translate } from 'rhg-vue-common';

//
//
//
//
//
//

var script$g = {
  name: 'Badge',
  props: {
    text: {
      type: String,
      required: true
    },
    squared: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: 'red-damask'
    },
    whiteSpace: {
      type: String,
      default: 'normal'
    }
  },
  computed: {
    badgeClasses() {
      return [
        { 'badge--square': this.squared },
        'bg-color-' + this.bgColor,
        this.squared ? 'color-dark-grey' : 'color-white',
        this.whiteSpace
      ]
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$g = script$g;

/* template */
var __vue_render__$g = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("span", { staticClass: "badge", class: _vm.badgeClasses }, [
    _vm._v("\n  " + _vm._s(_vm.text) + "\n"),
  ])
};
var __vue_staticRenderFns__$g = [];
__vue_render__$g._withStripped = true;

  /* style */
  const __vue_inject_styles__$g = function (inject) {
    if (!inject) return
    inject("data-v-6c447290_0", { source: ".badge[data-v-6c447290] {\n  white-space: normal;\n  display: inline-block;\n  margin: 0 0.8rem 0.8rem 0;\n  padding: 0.5rem 0.9rem;\n  font-size: 1.2rem;\n  font-weight: 300;\n  line-height: initial;\n  border-radius: 100rem;\n  cursor: default;\n}\n.badge--square[data-v-6c447290] {\n  padding: 0.4rem 1.2rem;\n  font-size: 1.4rem;\n  font-weight: 600;\n  border-radius: 0.4rem;\n}\n\n/*# sourceMappingURL=Badge.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-components/src/components/badges/Badge.vue","Badge.vue"],"names":[],"mappings":"AAyCA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,oBAAA;EAEA,qBAAA;EACA,eAAA;AC1CA;AD4CA;EACA,sBAAA;EAEA,iBAAA;EACA,gBAAA;EAEA,qBAAA;AC5CA;;AAEA,oCAAoC","file":"Badge.vue","sourcesContent":["<template>\n  <span class=\"badge\" :class=\"badgeClasses\">\n    {{ text }}\n  </span>\n</template>\n\n<script>\nexport default {\n  name: 'Badge',\n  props: {\n    text: {\n      type: String,\n      required: true\n    },\n    squared: {\n      type: Boolean,\n      default: false\n    },\n    bgColor: {\n      type: String,\n      default: 'red-damask'\n    },\n    whiteSpace: {\n      type: String,\n      default: 'normal'\n    }\n  },\n  computed: {\n    badgeClasses() {\n      return [\n        { 'badge--square': this.squared },\n        'bg-color-' + this.bgColor,\n        this.squared ? 'color-dark-grey' : 'color-white',\n        this.whiteSpace\n      ]\n    }\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n.badge {\n  white-space: normal;\n  display: inline-block;\n  margin: 0 .8rem .8rem 0;\n  padding: .5rem .9rem;\n\n  font-size: 1.2rem;\n  font-weight: 300;\n  line-height: initial;\n\n  border-radius: 100rem;\n  cursor: default;\n\n  &--square {\n    padding: .4rem 1.2rem;\n\n    font-size: 1.4rem;\n    font-weight: 600;\n\n    border-radius: .4rem;\n  }\n}\n</style>",".badge {\n  white-space: normal;\n  display: inline-block;\n  margin: 0 0.8rem 0.8rem 0;\n  padding: 0.5rem 0.9rem;\n  font-size: 1.2rem;\n  font-weight: 300;\n  line-height: initial;\n  border-radius: 100rem;\n  cursor: default;\n}\n.badge--square {\n  padding: 0.4rem 1.2rem;\n  font-size: 1.4rem;\n  font-weight: 600;\n  border-radius: 0.4rem;\n}\n\n/*# sourceMappingURL=Badge.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$g = "data-v-6c447290";
  /* module identifier */
  const __vue_module_identifier__$g = undefined;
  /* functional template */
  const __vue_is_functional_template__$g = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$g = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
    __vue_inject_styles__$g,
    __vue_script__$g,
    __vue_scope_id__$g,
    __vue_is_functional_template__$g,
    __vue_module_identifier__$g,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$f = {
  name: 'Button',
  props: {
    link: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'submit'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    big: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: '#c20808'
    },
    fontSize: {
      type: String,
      default: '1rem'
    },
    justifyContent: {
      type: String,
      default: 'center'
    }
  },
  computed: {
    tagType () {
      return this.link.href ? 'a' : 'button'
    },
    options () {
      return {
        id: this.id,
        'data-test-id': this.id,
        role: 'button',
        type: this.type,
        class: [
          'button',
          this.secondary ? 'button--secondary' : 'button--primary',
          this.big && 'button--big',
          this.loading && 'loading',
        ],
        style: {
          backgroundColor: this.disabled ? '#cccccc' : this.secondary ? 'transparent' : this.color,
          border: this.secondary ? '1px solid ' + this.color : 'none',
          justifyContent: this.justifyContent,
        },
        disabled: this.disabled,
        href: this.link.href
      }
    },
    getLabel () {
      return translate(this.label) || this.label
    },
    textStyle() {
      return {
        color: this.secondary ? this.color : 'white',
        fontSize: this.fontSize
      };
    }
  }
};

/* script */
const __vue_script__$f = script$f;

/* template */
var __vue_render__$f = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    _vm.tagType,
    _vm._b(
      {
        tag: "component",
        on: {
          click: function ($event) {
            return _vm.$emit("click")
          },
        },
      },
      "component",
      _vm.options,
      false
    ),
    [
      _vm.label && !_vm.loading
        ? _c(
            "span",
            { staticClass: "button__text", style: _vm.textStyle },
            [_vm._t("default", [_vm._v(_vm._s(_vm.getLabel))])],
            2
          )
        : _vm._e(),
    ]
  )
};
var __vue_staticRenderFns__$f = [];
__vue_render__$f._withStripped = true;

  /* style */
  const __vue_inject_styles__$f = function (inject) {
    if (!inject) return
    inject("data-v-c0406fe8_0", { source: ".button[data-v-c0406fe8] {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0.8rem 2.5rem;\n  border-radius: 5rem;\n  min-width: 12rem;\n  min-height: 3.6rem;\n}\n.button[data-v-c0406fe8]:focus {\n  outline: none;\n}\n.button__text[data-v-c0406fe8] {\n  text-transform: uppercase;\n  font-weight: bold;\n  line-height: normal;\n}\n.button.loading[data-v-c0406fe8] {\n  position: relative;\n  opacity: 0.8;\n  color: transparent;\n  pointer-events: none;\n}\n.button.loading[data-v-c0406fe8]:before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  background: transparent;\n  border: 1px solid white;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  box-sizing: border-box;\n  top: 50%;\n  left: 50%;\n  margin-top: -12px;\n  margin-left: -12px;\n  width: 24px;\n  height: 24px;\n  -webkit-animation: ld 1s ease-in-out infinite;\n  -moz-animation: ld 1s ease-in-out infinite;\n  -o-animation: ld 1s ease-in-out infinite;\n  animation: ld 1s ease-in-out infinite;\n}\n.button.loading[data-v-c0406fe8]:hover, .button.loading[data-v-c0406fe8]:active, .button.loading[data-v-c0406fe8]:focus {\n  cursor: default;\n  color: transparent;\n  box-shadow: 0 0 0 3px rgba(194, 8, 8, 0.25);\n}\n.button--secondary.loading[data-v-c0406fe8]:before {\n  border: 1px solid #c20808;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n}\n.button--big[data-v-c0406fe8] {\n  min-height: 4.8rem;\n}\n\n/*# sourceMappingURL=Button.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-components/src/components/buttons/Button.vue","Button.vue"],"names":[],"mappings":"AAuGA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;ACtGA;ADwGA;EACA,aAAA;ACtGA;ADyGA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;ACvGA;AD0GA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;ACxGA;AD0GA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,gCAAA;EACA,kBAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6CAAA;EACA,0CAAA;EACA,wCAAA;EACA,qCAAA;ACxGA;AD2GA;EAGA,eAAA;EACA,kBAAA;EACA,2CAAA;AC3GA;ADgHA;EACA,yBAAA;EACA,6BAAA;EACA,gCAAA;AC7GA;ADiHA;EACA,kBAAA;AC9GA;;AAEA,qCAAqC","file":"Button.vue","sourcesContent":["<template>\n  <component\n    :is=\"tagType\"\n    v-bind=\"options\"\n    @click=\"$emit('click')\"\n  >\n    <span v-if=\"label && !loading\"\n      class=\"button__text\"\n      :style=\"textStyle\"><slot>{{ getLabel }}</slot>\n    </span>\n  </component>\n</template>\n\n<script>\nimport { translate } from 'rhg-vue-common'\n\nexport default {\n  name: 'Button',\n  props: {\n    link: {\n      type: Object,\n      default: () => ({})\n    },\n    id: {\n      type: String,\n      required: true\n    },\n    label: {\n      type: String,\n      required: true\n    },\n    type: {\n      type: String,\n      default: 'submit'\n    },\n    disabled: {\n      type: Boolean,\n      default: false\n    },\n    loading: {\n      type: Boolean,\n      default: false\n    },\n    secondary: {\n      type: Boolean,\n      default: false\n    },\n    big: {\n      type: Boolean,\n      default: false\n    },\n    color: {\n      type: String,\n      default: '#c20808'\n    },\n    fontSize: {\n      type: String,\n      default: '1rem'\n    },\n    justifyContent: {\n      type: String,\n      default: 'center'\n    }\n  },\n  computed: {\n    tagType () {\n      return this.link.href ? 'a' : 'button'\n    },\n    options () {\n      return {\n        id: this.id,\n        'data-test-id': this.id,\n        role: 'button',\n        type: this.type,\n        class: [\n          'button',\n          this.secondary ? 'button--secondary' : 'button--primary',\n          this.big && 'button--big',\n          this.loading && 'loading',\n        ],\n        style: {\n          backgroundColor: this.disabled ? '#cccccc' : this.secondary ? 'transparent' : this.color,\n          border: this.secondary ? '1px solid ' + this.color : 'none',\n          justifyContent: this.justifyContent,\n        },\n        disabled: this.disabled,\n        href: this.link.href\n      }\n    },\n    getLabel () {\n      return translate(this.label) || this.label\n    },\n    textStyle() {\n      return {\n        color: this.secondary ? this.color : 'white',\n        fontSize: this.fontSize\n      };\n    }\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n.button {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  padding: .8rem 2.5rem;\n  border-radius: 5rem;\n  min-width: 12rem;\n  min-height: 3.6rem;\n\n  &:focus {\n    outline: none;\n  }\n\n  &__text {\n    text-transform: uppercase;\n    font-weight: bold;\n    line-height: normal;\n  }\n\n  &.loading {\n    position: relative;\n    opacity: 0.8;\n    color: transparent;\n    pointer-events: none;\n\n    &:before {\n      content: \"\";\n      display: inline-block;\n      position: absolute;\n      background: transparent;\n      border: 1px solid white;\n      border-top-color: transparent;\n      border-bottom-color: transparent;\n      border-radius: 50%;\n      box-sizing: border-box;\n      top: 50%;\n      left: 50%;\n      margin-top: -12px;\n      margin-left: -12px;\n      width: 24px;\n      height: 24px;\n      -webkit-animation: ld 1s ease-in-out infinite;\n      -moz-animation: ld 1s ease-in-out infinite;\n      -o-animation: ld 1s ease-in-out infinite;\n      animation: ld 1s ease-in-out infinite;\n    }\n\n    &:hover,\n    &:active,\n    &:focus {\n      cursor: default;\n      color: transparent;\n      box-shadow: 0 0 0 3px rgba(194, 8, 8, 0.25);\n    }\n  }\n}\n.button--secondary {\n  &.loading:before {\n    border: 1px solid #c20808;\n    border-top-color: transparent;\n    border-bottom-color: transparent;\n  }\n}\n\n.button--big {\n  min-height: 4.8rem;\n}\n</style>\n",".button {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0.8rem 2.5rem;\n  border-radius: 5rem;\n  min-width: 12rem;\n  min-height: 3.6rem;\n}\n.button:focus {\n  outline: none;\n}\n.button__text {\n  text-transform: uppercase;\n  font-weight: bold;\n  line-height: normal;\n}\n.button.loading {\n  position: relative;\n  opacity: 0.8;\n  color: transparent;\n  pointer-events: none;\n}\n.button.loading:before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  background: transparent;\n  border: 1px solid white;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  box-sizing: border-box;\n  top: 50%;\n  left: 50%;\n  margin-top: -12px;\n  margin-left: -12px;\n  width: 24px;\n  height: 24px;\n  -webkit-animation: ld 1s ease-in-out infinite;\n  -moz-animation: ld 1s ease-in-out infinite;\n  -o-animation: ld 1s ease-in-out infinite;\n  animation: ld 1s ease-in-out infinite;\n}\n.button.loading:hover, .button.loading:active, .button.loading:focus {\n  cursor: default;\n  color: transparent;\n  box-shadow: 0 0 0 3px rgba(194, 8, 8, 0.25);\n}\n\n.button--secondary.loading:before {\n  border: 1px solid #c20808;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n}\n\n.button--big {\n  min-height: 4.8rem;\n}\n\n/*# sourceMappingURL=Button.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$f = "data-v-c0406fe8";
  /* module identifier */
  const __vue_module_identifier__$f = undefined;
  /* functional template */
  const __vue_is_functional_template__$f = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$f = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
    __vue_inject_styles__$f,
    __vue_script__$f,
    __vue_scope_id__$f,
    __vue_is_functional_template__$f,
    __vue_module_identifier__$f,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$e = {
  name: 'SecondaryButton',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'submit'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    big: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: '#c20808'
    },
    fontSize: {
      type: String,
      default: '1rem'
    }
  },
  data () {
    return {
      borderColor: this.disabled ? '#cccccc' : this.color
    }
  },
  computed: {
    getLabel () {
      return translate(this.label) || this.label
    },
    style() {
      return {
        border: '1px solid ' + this.borderColor
      };
    },
    textStyle() {
      return {
        color: this.color,
        fontSize: this.fontSize
      };
    },
    classes() {
      return {
        'button--big': this.big,
        'loading': this.loading,
      };
    },
  }
};

/* script */
const __vue_script__$e = script$e;

/* template */
var __vue_render__$e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "button",
    {
      staticClass: "button button--secondary",
      class: _vm.classes,
      style: _vm.style,
      attrs: {
        id: _vm.id,
        "data-testid": _vm.id,
        role: "button",
        type: _vm.type,
        disabled: _vm.disabled,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _vm.label && !_vm.loading
        ? _c("span", { staticClass: "button__text", style: _vm.textStyle }, [
            _vm._v(_vm._s(_vm.getLabel)),
          ])
        : _vm._t("default"),
    ],
    2
  )
};
var __vue_staticRenderFns__$e = [];
__vue_render__$e._withStripped = true;

  /* style */
  const __vue_inject_styles__$e = function (inject) {
    if (!inject) return
    inject("data-v-15e73848_0", { source: ".button[data-v-15e73848] {\n  padding: 0.8rem 2.5rem;\n  border-radius: 5rem;\n  min-width: 12rem;\n  min-height: 3.6rem;\n  background-color: transparent;\n}\n.button[data-v-15e73848]:focus {\n  outline: none;\n}\n.button__text[data-v-15e73848] {\n  text-transform: uppercase;\n  font-weight: bold;\n}\n.button.loading[data-v-15e73848] {\n  position: relative;\n  opacity: 0.8;\n  color: transparent;\n  pointer-events: none;\n}\n.button.loading[data-v-15e73848]:before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  background: transparent;\n  border: 1px solid white;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  box-sizing: border-box;\n  top: 50%;\n  left: 50%;\n  margin-top: -12px;\n  margin-left: -12px;\n  width: 24px;\n  height: 24px;\n  -webkit-animation: ld 1s ease-in-out infinite;\n  -moz-animation: ld 1s ease-in-out infinite;\n  -o-animation: ld 1s ease-in-out infinite;\n  animation: ld 1s ease-in-out infinite;\n}\n.button.loading[data-v-15e73848]:hover, .button.loading[data-v-15e73848]:active, .button.loading[data-v-15e73848]:focus {\n  cursor: default;\n  color: transparent;\n  box-shadow: 0 0 0 3px rgba(194, 8, 8, 0.25);\n}\n.button--secondary.loading[data-v-15e73848]:before {\n  border: 1px solid #c20808;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n}\n.button--big[data-v-15e73848] {\n  min-height: 4.8rem;\n}\n\n/*# sourceMappingURL=SecondaryButton.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-components/src/components/buttons/SecondaryButton.vue","SecondaryButton.vue"],"names":[],"mappings":"AA8EA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;AC7EA;AD+EA;EACA,aAAA;AC7EA;ADgFA;EACA,yBAAA;EACA,iBAAA;AC9EA;ADiFA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;AC/EA;ADiFA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,gCAAA;EACA,kBAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6CAAA;EACA,0CAAA;EACA,wCAAA;EACA,qCAAA;AC/EA;ADkFA;EAGA,eAAA;EACA,kBAAA;EACA,2CAAA;AClFA;ADuFA;EACA,yBAAA;EACA,6BAAA;EACA,gCAAA;ACpFA;ADwFA;EACA,kBAAA;ACrFA;;AAEA,8CAA8C","file":"SecondaryButton.vue","sourcesContent":["<template>\n  <button :id=\"id\" :data-testid=\"id\" role=\"button\" :type=\"type\" class=\"button button--secondary\" :class=\"classes\"\n          :style=\"style\" :disabled=\"disabled\" @click=\"$emit('click')\" >\n    <span v-if=\"label && !loading\" class=\"button__text\" :style=\"textStyle\" >{{ getLabel }}</span>\n    <slot v-else/>\n  </button>\n</template>\n\n<script>\nimport { translate } from 'rhg-vue-common'\n\nexport default {\n  name: 'SecondaryButton',\n  props: {\n    id: {\n      type: String,\n      required: true\n    },\n    label: {\n      type: String,\n      required: true\n    },\n    type: {\n      type: String,\n      default: 'submit'\n    },\n    disabled: {\n      type: Boolean,\n      default: false\n    },\n    loading: {\n      type: Boolean,\n      default: false\n    },\n    big: {\n      type: Boolean,\n      default: false\n    },\n    color: {\n      type: String,\n      default: '#c20808'\n    },\n    fontSize: {\n      type: String,\n      default: '1rem'\n    }\n  },\n  data () {\n    return {\n      borderColor: this.disabled ? '#cccccc' : this.color\n    }\n  },\n  computed: {\n    getLabel () {\n      return translate(this.label) || this.label\n    },\n    style() {\n      return {\n        border: '1px solid ' + this.borderColor\n      };\n    },\n    textStyle() {\n      return {\n        color: this.color,\n        fontSize: this.fontSize\n      };\n    },\n    classes() {\n      return {\n        'button--big': this.big,\n        'loading': this.loading,\n      };\n    },\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n.button {\n  padding: .8rem 2.5rem;\n  border-radius: 5rem;\n  min-width: 12rem;\n  min-height: 3.6rem;\n  background-color: transparent;\n\n  &:focus {\n    outline: none;\n  }\n\n  &__text {\n    text-transform: uppercase;\n    font-weight: bold;\n  }\n\n  &.loading {\n    position: relative;\n    opacity: 0.8;\n    color: transparent;\n    pointer-events: none;\n\n    &:before {\n      content: \"\";\n      display: inline-block;\n      position: absolute;\n      background: transparent;\n      border: 1px solid white;\n      border-top-color: transparent;\n      border-bottom-color: transparent;\n      border-radius: 50%;\n      box-sizing: border-box;\n      top: 50%;\n      left: 50%;\n      margin-top: -12px;\n      margin-left: -12px;\n      width: 24px;\n      height: 24px;\n      -webkit-animation: ld 1s ease-in-out infinite;\n      -moz-animation: ld 1s ease-in-out infinite;\n      -o-animation: ld 1s ease-in-out infinite;\n      animation: ld 1s ease-in-out infinite;\n    }\n\n    &:hover,\n    &:active,\n    &:focus {\n      cursor: default;\n      color: transparent;\n      box-shadow: 0 0 0 3px rgba(194, 8, 8, 0.25);\n    }\n  }\n}\n.button--secondary {\n  &.loading:before {\n    border: 1px solid #c20808;\n    border-top-color: transparent;\n    border-bottom-color: transparent;\n  }\n}\n\n.button--big {\n  min-height: 4.8rem;\n}\n</style>\n",".button {\n  padding: 0.8rem 2.5rem;\n  border-radius: 5rem;\n  min-width: 12rem;\n  min-height: 3.6rem;\n  background-color: transparent;\n}\n.button:focus {\n  outline: none;\n}\n.button__text {\n  text-transform: uppercase;\n  font-weight: bold;\n}\n.button.loading {\n  position: relative;\n  opacity: 0.8;\n  color: transparent;\n  pointer-events: none;\n}\n.button.loading:before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  background: transparent;\n  border: 1px solid white;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  box-sizing: border-box;\n  top: 50%;\n  left: 50%;\n  margin-top: -12px;\n  margin-left: -12px;\n  width: 24px;\n  height: 24px;\n  -webkit-animation: ld 1s ease-in-out infinite;\n  -moz-animation: ld 1s ease-in-out infinite;\n  -o-animation: ld 1s ease-in-out infinite;\n  animation: ld 1s ease-in-out infinite;\n}\n.button.loading:hover, .button.loading:active, .button.loading:focus {\n  cursor: default;\n  color: transparent;\n  box-shadow: 0 0 0 3px rgba(194, 8, 8, 0.25);\n}\n\n.button--secondary.loading:before {\n  border: 1px solid #c20808;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n}\n\n.button--big {\n  min-height: 4.8rem;\n}\n\n/*# sourceMappingURL=SecondaryButton.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$e = "data-v-15e73848";
  /* module identifier */
  const __vue_module_identifier__$e = undefined;
  /* functional template */
  const __vue_is_functional_template__$e = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$e = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
    __vue_inject_styles__$e,
    __vue_script__$e,
    __vue_scope_id__$e,
    __vue_is_functional_template__$e,
    __vue_module_identifier__$e,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$d = {
    name: 'Countdown',
    props: {
        counterOnly: {
            type: Boolean,
            default: false
        },
        expiryDate: {
            type: String,
            default: ''
        },
        labelOnly: {
            type: Boolean,
            default: false
        },
        short:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isLoading: true,
            endDate: null,
            currentDate: null,
            intervalId: null,
            days: null,
            hours: null,
            minutes: null,
            seconds: null
        }
    },
    mounted() {
        if (!this.labelOnly) {
            this.endDate = new Date(this.expiryDate);
            this.intervalId = this.startCountDown();
        }
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
    },
    computed: {
        dealOfTheDay() {
            return translate('boDealOfTheDay')
        },
        endsIn() {
            return translate('boEndsIn').split('{0}').join(this.hoursAndMinutes)
        },
        hoursAndMinutes() {
            return translate('boHoursAndMinutes').split('{0}').join(`${this.hoursFormat}`).split('{1}').join(`${this.minutesFormat}`)
        },
        endingSoon() {
            return translate('boEndingSoon')
        },
        expired() {
            return translate('boExpired')
        },
        isFullFormat() {
            return this.hours > 0 || (this.hours === 0 && this.minutes > 15)
        },
        isEndingSoon() {
            return this.minutes < 15 && (this.minutes > 1 || (this.minutes === 1 && this.seconds > 0))
        },
        isExpired() {
            return this.minutes <= 1 && this.hours <= 0
        },
        hoursFormat() {
            return `${this.hours}`.padStart(2, '0')
        },
        minutesFormat() {
            return `${this.minutes}`.padStart(2, '0')
        }
    },
    methods: {
        startCountDown() {
            return setInterval(() => {
                this.currentDate = new Date().getTime();
                let distance = this.endDate - this.currentDate;

                this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
                this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + Math.floor(this.days * 24);
                this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                this.seconds = Math.floor((distance % (1000 * 60)) / 1000);

                this.isLoading = false;
                if (distance < 0) {
                    clearInterval(this.intervalId);
                    this.$emit('expire');
                }
            }, 1000)
        },
        fixBorderRadius(prop) {
            return prop ? {borderRadius: '3px'} : {}
        },
    }
};

/* script */
const __vue_script__$d = script$d;

/* template */
var __vue_render__$d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "countdown_card", attrs: { id: "countdown" } },
    [
      !_vm.counterOnly
        ? _c(
            "div",
            {
              staticClass: "deal-of-the-day-col",
              style: [_vm.fixBorderRadius(_vm.labelOnly)],
            },
            [
              _c("p", { staticClass: "mb-0 mr-2 text-white" }, [
                _c("i", { staticClass: "icon-clock xs" }),
                _vm._v(_vm._s(_vm.dealOfTheDay)),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isFullFormat && !_vm.labelOnly && !_vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "counter-time-col",
              style: [_vm.fixBorderRadius(_vm.counterOnly)],
            },
            [
              _c("p", { staticClass: "mb-0 ml-2 mr-2 counter-time-text" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.short ? _vm.hoursAndMinutes : _vm.endsIn) +
                    " "
                ),
              ]),
            ]
          )
        : _vm.isEndingSoon && !_vm.labelOnly && !_vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "counter-time-col",
              style: [_vm.fixBorderRadius(_vm.counterOnly)],
            },
            [
              _c("p", { staticClass: "mb-0 ml-2 mr-2 counter-time-text" }, [
                _vm._v(_vm._s(_vm.endingSoon)),
              ]),
            ]
          )
        : _vm.isExpired && !_vm.labelOnly && !_vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "counter-time-col",
              style: [_vm.fixBorderRadius(_vm.counterOnly)],
            },
            [
              _c("p", { staticClass: "mb-0 ml-2 mr-2 counter-time-text" }, [
                _vm._v(_vm._s(_vm.expired)),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
};
var __vue_staticRenderFns__$d = [];
__vue_render__$d._withStripped = true;

  /* style */
  const __vue_inject_styles__$d = function (inject) {
    if (!inject) return
    inject("data-v-64f4e2e7_0", { source: ".countdown_card[data-v-64f4e2e7] {\n  height: 2rem;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n@media (max-width: 540px) {\n.countdown_card[data-v-64f4e2e7] {\n    justify-content: initial;\n}\n}\n.countdown_card p[data-v-64f4e2e7], .countdown_card text[data-v-64f4e2e7] {\n  font-size: 1.1rem;\n  font-weight: bold;\n}\n.deal-of-the-day-col[data-v-64f4e2e7] {\n  border: 1px solid #E76B13;\n  background-color: #E76B13;\n  border-radius: 3px 0 0 3px;\n}\n.deal-of-the-day-col i[data-v-64f4e2e7] {\n  margin-right: 5px;\n  margin-left: 5px;\n}\n.counter-time-col[data-v-64f4e2e7] {\n  background-color: white;\n  border: 1px solid #E76B13;\n  border-radius: 0px 3px 3px 0px;\n}\n.counter-time-col .counter-time-text[data-v-64f4e2e7] {\n  color: #E76B13;\n  margin-left: 10px;\n}\n\n/*# sourceMappingURL=Countdown.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-components/src/components/texts/Countdown.vue","Countdown.vue"],"names":[],"mappings":"AAyHA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;ACxHA;ADyHA;AANA;IAOA,wBAAA;ACtHE;AACF;ADuHA;EACA,iBAAA;EACA,iBAAA;ACrHA;ADyHA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;ACtHA;ADwHA;EACA,iBAAA;EACA,gBAAA;ACtHA;ADyHA;EACA,uBAAA;EACA,yBAAA;EACA,8BAAA;ACtHA;ADwHA;EACA,cAAA;EACA,iBAAA;ACtHA;;AAEA,wCAAwC","file":"Countdown.vue","sourcesContent":["<template>\n    <div id=\"countdown\" class=\"countdown_card\">\n        <div class=\"deal-of-the-day-col\" v-if= \"!counterOnly\" :style=\"[fixBorderRadius(labelOnly)]\">\n            <p class=\"mb-0 mr-2 text-white\"><i class=\"icon-clock xs\"></i>{{ dealOfTheDay }}</p>\n        </div>\n        <div class=\"counter-time-col\" v-if=\"isFullFormat && !labelOnly && !isLoading\" :style=\"[fixBorderRadius(counterOnly)]\">\n            <p class=\"mb-0 ml-2 mr-2 counter-time-text\"> {{ short ? hoursAndMinutes : endsIn }} </p>\n        </div>\n        <div class=\"counter-time-col\" v-else-if=\"isEndingSoon && !labelOnly && !isLoading\" :style=\"[fixBorderRadius(counterOnly)]\">\n            <p class=\"mb-0 ml-2 mr-2 counter-time-text\">{{ endingSoon }}</p>\n        </div>\n        <div class=\"counter-time-col\" v-else-if=\"isExpired && !labelOnly && !isLoading\" :style=\"[fixBorderRadius(counterOnly)]\">\n            <p class=\"mb-0 ml-2 mr-2 counter-time-text\">{{ expired }}</p>\n        </div>\n    </div>\n</template>\n\n<script>\n\nimport { translate } from 'rhg-vue-common'\n\nexport default {\n    name: 'Countdown',\n    props: {\n        counterOnly: {\n            type: Boolean,\n            default: false\n        },\n        expiryDate: {\n            type: String,\n            default: ''\n        },\n        labelOnly: {\n            type: Boolean,\n            default: false\n        },\n        short:{\n            type: Boolean,\n            default: false\n        }\n    },\n    data() {\n        return {\n            isLoading: true,\n            endDate: null,\n            currentDate: null,\n            intervalId: null,\n            days: null,\n            hours: null,\n            minutes: null,\n            seconds: null\n        }\n    },\n    mounted() {\n        if (!this.labelOnly) {\n            this.endDate = new Date(this.expiryDate)\n            this.intervalId = this.startCountDown()\n        }\n    },\n    beforeDestroy() {\n        clearInterval(this.intervalId)\n    },\n    computed: {\n        dealOfTheDay() {\n            return translate('boDealOfTheDay')\n        },\n        endsIn() {\n            return translate('boEndsIn').split('{0}').join(this.hoursAndMinutes)\n        },\n        hoursAndMinutes() {\n            return translate('boHoursAndMinutes').split('{0}').join(`${this.hoursFormat}`).split('{1}').join(`${this.minutesFormat}`)\n        },\n        endingSoon() {\n            return translate('boEndingSoon')\n        },\n        expired() {\n            return translate('boExpired')\n        },\n        isFullFormat() {\n            return this.hours > 0 || (this.hours === 0 && this.minutes > 15)\n        },\n        isEndingSoon() {\n            return this.minutes < 15 && (this.minutes > 1 || (this.minutes === 1 && this.seconds > 0))\n        },\n        isExpired() {\n            return this.minutes <= 1 && this.hours <= 0\n        },\n        hoursFormat() {\n            return `${this.hours}`.padStart(2, '0')\n        },\n        minutesFormat() {\n            return `${this.minutes}`.padStart(2, '0')\n        }\n    },\n    methods: {\n        startCountDown() {\n            return setInterval(() => {\n                this.currentDate = new Date().getTime()\n                let distance = this.endDate - this.currentDate\n\n                this.days = Math.floor(distance / (1000 * 60 * 60 * 24))\n                this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + Math.floor(this.days * 24)\n                this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))\n                this.seconds = Math.floor((distance % (1000 * 60)) / 1000)\n\n                this.isLoading = false\n                if (distance < 0) {\n                    clearInterval(this.intervalId)\n                    this.$emit('expire')\n                }\n            }, 1000)\n        },\n        fixBorderRadius(prop) {\n            return prop ? {borderRadius: '3px'} : {}\n        },\n    }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n\n.countdown_card{\n    height: 2rem;\n    width: 100%;\n    display:flex;\n    align-items: center;\n    justify-content: end;\n    @media (max-width: 540px) {\n        justify-content: initial;\n    }\n    p, text{\n        font-size: 1.1rem;\n        font-weight: bold;\n    }\n}\n\n.deal-of-the-day-col{\n    border: 1px solid #E76B13;\n    background-color: #E76B13;\n    border-radius: 3px 0 0 3px;\n\n    i {\n        margin-right: 5px;\n        margin-left: 5px;\n    }\n}\n.counter-time-col{\n    background-color: white;\n    border: 1px solid #E76B13;\n    border-radius: 0px 3px 3px 0px;\n\n    .counter-time-text{\n        color: #E76B13;\n        margin-left: 10px;\n    }\n\n}\n</style>\n",".countdown_card {\n  height: 2rem;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n@media (max-width: 540px) {\n  .countdown_card {\n    justify-content: initial;\n  }\n}\n.countdown_card p, .countdown_card text {\n  font-size: 1.1rem;\n  font-weight: bold;\n}\n\n.deal-of-the-day-col {\n  border: 1px solid #E76B13;\n  background-color: #E76B13;\n  border-radius: 3px 0 0 3px;\n}\n.deal-of-the-day-col i {\n  margin-right: 5px;\n  margin-left: 5px;\n}\n\n.counter-time-col {\n  background-color: white;\n  border: 1px solid #E76B13;\n  border-radius: 0px 3px 3px 0px;\n}\n.counter-time-col .counter-time-text {\n  color: #E76B13;\n  margin-left: 10px;\n}\n\n/*# sourceMappingURL=Countdown.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$d = "data-v-64f4e2e7";
  /* module identifier */
  const __vue_module_identifier__$d = undefined;
  /* functional template */
  const __vue_is_functional_template__$d = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$d = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
    __vue_inject_styles__$d,
    __vue_script__$d,
    __vue_scope_id__$d,
    __vue_is_functional_template__$d,
    __vue_module_identifier__$d,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$c = {
  name: 'ExpirationBadge',
  components: {
    Badge: __vue_component__$g
  },
  props: {
    text: {
      type: String,
      required: true
    },
    expired: {
      type: Boolean
    }
  },
  methods: {
    translate
  }
};

/* script */
const __vue_script__$c = script$c;

/* template */
var __vue_render__$c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "span",
    { staticClass: "expiration-badge" },
    [
      _c("span", { staticClass: "expiration-badge__text color-gunmetal" }, [
        _vm._v(_vm._s(_vm.text)),
      ]),
      _vm._v(" "),
      _vm.expired
        ? _c("Badge", {
            attrs: {
              text: _vm.translate("paExpiresSoon"),
              bgColor: "alert-box",
              squared: "",
            },
          })
        : _vm._e(),
    ],
    1
  )
};
var __vue_staticRenderFns__$c = [];
__vue_render__$c._withStripped = true;

  /* style */
  const __vue_inject_styles__$c = function (inject) {
    if (!inject) return
    inject("data-v-58aae82e_0", { source: ".expiration-badge__text[data-v-58aae82e] {\n  display: inline-block;\n  margin: 0 0.8rem 0.4rem 0;\n  padding: 0.4rem 0;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: initial;\n}\n\n/*# sourceMappingURL=ExpirationBadge.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-components/src/components/badges/ExpirationBadge.vue","ExpirationBadge.vue"],"names":[],"mappings":"AAsCA;EACA,qBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;ACrCA;;AAEA,8CAA8C","file":"ExpirationBadge.vue","sourcesContent":["<template>\n  <span class=\"expiration-badge\">\n    <span class=\"expiration-badge__text color-gunmetal\">{{ text }}</span>\n    <Badge v-if=\"expired\" \n      :text=\"translate('paExpiresSoon')\"\n      bgColor=\"alert-box\"\n      squared\n    />\n  </span>\n</template>\n\n<script>\nimport { translate } from 'rhg-vue-common'\nimport Badge from './Badge.vue'\n\nexport default {\n  name: 'ExpirationBadge',\n  components: {\n    Badge\n  },\n  props: {\n    text: {\n      type: String,\n      required: true\n    },\n    expired: {\n      type: Boolean\n    }\n  },\n  methods: {\n    translate\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n\n.expiration-badge {\n  &__text {\n    display: inline-block;\n    margin: 0 .8rem .4rem 0;\n    padding: .4rem 0;\n    font-weight: 400;\n    font-size: 1.4rem;\n    line-height: initial;\n  }\n}\n\n</style>",".expiration-badge__text {\n  display: inline-block;\n  margin: 0 0.8rem 0.4rem 0;\n  padding: 0.4rem 0;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: initial;\n}\n\n/*# sourceMappingURL=ExpirationBadge.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$c = "data-v-58aae82e";
  /* module identifier */
  const __vue_module_identifier__$c = undefined;
  /* functional template */
  const __vue_is_functional_template__$c = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$c = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
    __vue_inject_styles__$c,
    __vue_script__$c,
    __vue_scope_id__$c,
    __vue_is_functional_template__$c,
    __vue_module_identifier__$c,
    false,
    createInjector,
    undefined,
    undefined
  );

//
var script$b = {
  name: 'SocialMediaMenu',
  props: {
    overviewPath: {
      required: true,
      type: String
    },
    vueApp: {
      required: true,
      type: String
    }
  },
  data: () => ({
    windowSharingOptions:
      'width=600, height=400, location=0, menubar=0, resizeable=0, scrollbars=0, status=0, titlebar=0, toolbar=0',
    socialMediaList: [],
    linksToShare: {
      facebook: 'https://www.facebook.com/sharer.php?u=%{url}',
      twitter: 'https://www.twitter.com/share?url=%{url}',
      pinterest: 'https://www.pinterest.com/pin/create/button/?url=%{url}',
      linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=%{url}',
      wechat: 'https://www.shareaholic.com/share/wechat/?link=%{url}',
      vkontakte: 'https://vk.com/share.php?url=%{url}',
      weibo: 'http://service.weibo.com/share/share.php?url=%{url}&title=%{title}',
      email: `mailto:?subject=${global.document.title}&body=%{url}`,
      whatsapp: 'https://api.whatsapp.com/send?text=%{url}'
    }
  }),
  created() {
    const { VUE_APP: { [this.vueApp]: { socialMedia = [] } = {} } = {} } = global;
    this.socialMediaList = socialMedia.map(socialMediaName => ({
      name: socialMediaName,
      link: this.linksToShare[socialMediaName.toLowerCase()]
    }));
  },
  methods: {
    async share({ link }) {
      this.trackSelectedSocialMedia();
      window.open(
        this.sharingUrl(link, this.overviewPath),
        null,
        this.windowSharingOptions
      );
    },
    sharingUrl(link, overviewPath) {
      const webExtraUrl = `${global.location.origin}${overviewPath}`;
      return link.replace('%{url}', webExtraUrl).replace('%{title}', webExtraUrl)
    },
    trackSelectedSocialMedia() {
      global.trackingService.track(global.trackingEvents.SOCIAL_MEDIA_SHARE);
    }
  },
  computed: {
      shareLabel() {
          return translate('weShare')
      }
  }
};

/* script */
const __vue_script__$b = script$b;

/* template */
var __vue_render__$b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "dropdown dropdown-customer show d-inline-block",
      attrs: { "data-testid": "social-media-menu" },
    },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-link text-bold text-12",
          attrs: {
            type: "button",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false",
            "aria-controls": "social-media-sharing",
            id: "social-media-sharing",
            "aria-label": "social media share",
          },
        },
        [
          _c("i", { staticClass: "color-white icon-share xs" }),
          _vm._v(" "),
          _c("span", { staticClass: "sr-only sr-only-focusable" }, [
            _vm._v(_vm._s(_vm.shareLabel)),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dropdown-menu share-social-icon",
          attrs: {
            "aria-labelledby": "social-media-sharing",
            "aria-label": "social-media-sharing",
            role: "menu",
          },
        },
        [
          _c("div", { staticClass: "dropdown-menu-icon" }, [
            _c(
              "ul",
              _vm._l(_vm.socialMediaList, function (media) {
                return _c("li", { key: media.name }, [
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item text-14 share-button",
                      attrs: { rel: "nofollow" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault();
                          return _vm.share(media)
                        },
                      },
                    },
                    [_vm._v(_vm._s(media.name))]
                  ),
                ])
              }),
              0
            ),
          ]),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$b = [];
__vue_render__$b._withStripped = true;

  /* style */
  const __vue_inject_styles__$b = undefined;
  /* scoped */
  const __vue_scope_id__$b = undefined;
  /* module identifier */
  const __vue_module_identifier__$b = undefined;
  /* functional template */
  const __vue_is_functional_template__$b = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$b = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
    __vue_inject_styles__$b,
    __vue_script__$b,
    __vue_scope_id__$b,
    __vue_is_functional_template__$b,
    __vue_module_identifier__$b,
    false,
    undefined,
    undefined,
    undefined
  );

function buildImageUrl(mediaUrl, impolicy, gravity) {
  if (mediaUrl) {
    let url = mediaUrl + "?impolicy=" + impolicy;
    if (gravity) {
      url += "&gravity=" + gravity;
    }
    return url;
  }
  return mediaUrl;
}

//

var script$a = {
  components: {
    SocialMediaMenu: __vue_component__$b
  },
  props: {
    /**
    * Room or hotel code or id
    */
    code: {
      required: true,
      type: String
    },
    /**
    * Room gallery
    * Required for rooms
    */
    roomGallery: {
      type: Array
    },
    /**
    * Hotel galleries
    * Required for hotels
    */
    hotelGalleries: {
      type: Array
    },
    /**
    * Relative url to redirect.
    * This prop is required to show SocialMediaMenu
    */
    overviewPath: String,
    /**
     * Vue app where gallery modal is being included, ej: searchMapDestinations, searchResults, roomDisplay.
     * This prop is required to show SocialMediaMenu
     */
    vueApp: String
  },
  data: () => ({
    categories: [],
    gallery: {},
    isHotel: ''
  }),
  beforeMount() {
    this.isHotel = !!this.hotelGalleries;
    this.categories = this.isHotel ? this.parseCategories() : [];
  },
  mounted() {
    this.gallery = this.parseGallery();
    this.initGallery();
  },
  methods: {
    parseCategories() {
      return this.hotelGalleries.map(({ category }) => ({
        code: category.toLowerCase(),
        name: category
      }))
    },
    parseGallery() {
      return this.isHotel ? this.parseHotelGallery() : this.parseRoomGallery()
    },
    parseHotelGallery() {
      return this.hotelGalleries.reduce(
        (slides, { category, gallery }) => ({
          ...slides,
          [category.toLowerCase()]: gallery.map((slide, index) => this.buildGallery(slide, index))
        }),
        {}
      )
    },
    parseRoomGallery() {
      return this.roomGallery.map((slide, index) => this.buildGallery(slide, index))
    },
    buildGallery(slide, index) {
      let item;
      if (slide.mimeType && slide.mimeType.includes('video')) {
        item = {
          id: this.code + index,
          name: slide.name,
          posterUrl: buildImageUrl(slide.posterUrl, 'GalleryLightbox', slide.gravity),
          thumbnailUrl: buildImageUrl(slide.thumbnailUrl, 'GalleryLightboxThum', slide.gravity),
          videoUrl: slide.url,
          title: slide.title,
          languagesInfo: slide.captions
        };
      } else {
        item = {
          alt: slide.altText,
          src: buildImageUrl(slide.url, 'GalleryLightbox', slide.gravity),
          srcThumbnail: buildImageUrl(slide.url, 'GalleryLightboxThum', slide.gravity)
        };
      }
      return item
    },
    initGallery() {
      if (typeof WeModalGallery === 'undefined') {
        return
      }
      // eslint-disable-next-line no-undef
      global.weModalGallerySliders = global.weModalGallerySliders || [];
      global.weModalGallerySliders.push({
        selector: `#${this.code}`,
        slides: this.isHotel ? this.gallery : {
          [this.code]: this.gallery
        },
        isVueGallery: true
      });
      // eslint-disable-next-line no-undef
      global.WeSetupVideo.init();
      global.WeModalGallery.init();
    }
  }
};

/* script */
const __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "modal fade entity-modal-gallery",
      attrs: {
        "data-testid": "gallery-modal",
        id: _vm.code,
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": _vm.code,
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered modal-xl",
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c(
              "div",
              { staticClass: "modal-header justify-content-end" },
              [
                _vm.overviewPath && _vm.vueApp
                  ? _c("SocialMediaMenu", {
                      attrs: {
                        overviewPath: _vm.overviewPath,
                        vueApp: _vm.vueApp,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._m(0),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body position-relative" }, [
              _vm._m(1),
              _vm._v(" "),
              _vm.isHotel
                ? _c("div", { staticClass: "wrap-navbar-galleries bg-white" }, [
                    _c(
                      "nav",
                      { staticClass: "navbar navbar-expand-lg navbar-light" },
                      [
                        _c(
                          "ul",
                          { staticClass: "nav nav-tabs" },
                          _vm._l(_vm.categories, function (ref, index) {
                            var code = ref.code;
                            var name = ref.name;
                            return _c(
                              "li",
                              { key: code + index, staticClass: "nav-item" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "nav-link",
                                    attrs: { "data-gallery": code },
                                  },
                                  [_vm._v(_vm._s(name))]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "gallery-thumbs-slider" }),
            ]),
          ]),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$a = [
  function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span"), _vm._v(" "), _c("span")]
    )
  },
  function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "wrap-main-slider" }, [
      _c(
        "div",
        {
          staticClass: "spinner-box spinner-box-slider",
          attrs: { id: "spinner-load-gallery" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "spinner-loader spinner-loader--white spinner-slider",
            },
            [
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c("div"),
              _vm._v(" "),
              _c("div"),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "gallery-slider" }),
    ])
  },
];
__vue_render__$a._withStripped = true;

  /* style */
  const __vue_inject_styles__$a = undefined;
  /* scoped */
  const __vue_scope_id__$a = undefined;
  /* module identifier */
  const __vue_module_identifier__$a = undefined;
  /* functional template */
  const __vue_is_functional_template__$a = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$a = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
    __vue_inject_styles__$a,
    __vue_script__$a,
    __vue_scope_id__$a,
    __vue_is_functional_template__$a,
    __vue_module_identifier__$a,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//

var script$9 = {
  name: 'Price',
  props: {
    preQtyText: String,
    quantity: {
      type: String,
      default: '',
      required: true
    },
    postQtyText: String
  }
};

/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "price" }, [
    _vm.preQtyText
      ? _c("span", { staticClass: "price__pre color-dove-gray" }, [
          _vm._v(_vm._s(_vm.preQtyText)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("span", { staticClass: "price__quantity" }, [
      _vm._v(_vm._s(_vm.quantity)),
    ]),
    _vm._v(" "),
    _vm.postQtyText
      ? _c("span", { staticClass: "price__post color-dove-gray" }, [
          _vm._v(_vm._s(_vm.postQtyText)),
        ])
      : _vm._e(),
  ])
};
var __vue_staticRenderFns__$9 = [];
__vue_render__$9._withStripped = true;

  /* style */
  const __vue_inject_styles__$9 = function (inject) {
    if (!inject) return
    inject("data-v-da107fb2_0", { source: ".price[data-v-da107fb2] {\n  display: flex;\n  align-items: baseline;\n}\n.price span[data-v-da107fb2] {\n  display: inline-block;\n}\n.price__pre[data-v-da107fb2], .price__post[data-v-da107fb2] {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n}\n.price__pre[data-v-da107fb2]::after, .price__post[data-v-da107fb2]::before {\n  content: \" \";\n  white-space: break-spaces;\n}\n.price__quantity[data-v-da107fb2] {\n  font-weight: bold;\n  font-size: 2rem;\n  line-height: 2.6rem;\n}\n\n/*# sourceMappingURL=Price.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-components/src/components/texts/Price.vue","Price.vue"],"names":[],"mappings":"AAyBA;EACA,aAAA;EACA,qBAAA;ACxBA;AD0BA;EACA,qBAAA;ACxBA;AD2BA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;ACzBA;AD4BA;EACA,YAAA;EACA,yBAAA;AC1BA;AD6BA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AC3BA;;AAEA,oCAAoC","file":"Price.vue","sourcesContent":["<template>\n  <div class=\"price\">\n    <span class=\"price__pre color-dove-gray\" v-if=\"preQtyText\">{{ preQtyText }}</span>\n    <span class=\"price__quantity\">{{ quantity }}</span>\n    <span class=\"price__post color-dove-gray\" v-if=\"postQtyText\">{{ postQtyText }}</span>\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'Price',\n  props: {\n    preQtyText: String,\n    quantity: {\n      type: String,\n      default: '',\n      required: true\n    },\n    postQtyText: String\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n\n.price {\n  display: flex;\n  align-items: baseline;\n\n  span {\n    display: inline-block;\n  }\n\n  &__pre, &__post {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 1.4rem;\n    line-height: 2rem;\n  }\n\n  &__pre::after, &__post::before {\n    content: ' ';\n    white-space: break-spaces;\n  }\n\n  &__quantity {\n    font-weight: bold;\n    font-size: 2rem;\n    line-height: 2.6rem;\n  }\n}\n\n</style>",".price {\n  display: flex;\n  align-items: baseline;\n}\n.price span {\n  display: inline-block;\n}\n.price__pre, .price__post {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.4rem;\n  line-height: 2rem;\n}\n.price__pre::after, .price__post::before {\n  content: \" \";\n  white-space: break-spaces;\n}\n.price__quantity {\n  font-weight: bold;\n  font-size: 2rem;\n  line-height: 2.6rem;\n}\n\n/*# sourceMappingURL=Price.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$9 = "data-v-da107fb2";
  /* module identifier */
  const __vue_module_identifier__$9 = undefined;
  /* functional template */
  const __vue_is_functional_template__$9 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$9 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$8 = {
  name: 'TripAdvisor',
  props: {
    totalReviews: {
      type: Number,
      required: true
    },
    rating: {
      type: Number,
      required: true
    }
  },
  methods: {
    getRatingImageForNumber() {
      return `https://www.tripadvisor.com/img/cdsi/img2/ratings/traveler/s${this.rating.toFixed(1)}-MCID-5.svg`
    }
  },
  computed: {
    getLabel () {
      return translate('promoReviews', this.totalReviews, this.totalReviews)
    },}

};

/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "rating" }, [
    _c("span", { staticClass: "rating__number font-bold" }, [
      _vm._v(_vm._s(_vm.rating)),
    ]),
    _vm._v(" "),
    _c("img", {
      staticClass: "rating__points-image",
      attrs: {
        src: _vm.getRatingImageForNumber(),
        "data-src": _vm.getRatingImageForNumber(),
        alt: _vm.getLabel,
      },
    }),
    _vm._v(" "),
    _c("span", { staticClass: "font-bold" }, [
      _vm._v("(" + _vm._s(_vm.getLabel) + ")"),
    ]),
  ])
};
var __vue_staticRenderFns__$8 = [];
__vue_render__$8._withStripped = true;

  /* style */
  const __vue_inject_styles__$8 = function (inject) {
    if (!inject) return
    inject("data-v-6d9867a1_0", { source: ".rating {\n  display: flex;\n  gap: 0.8rem;\n  align-items: center;\n}\n.rating__number {\n  padding: 0.4rem 0.8rem;\n  gap: 1rem;\n  background-color: #00AA6C;\n  border-radius: 3.9rem;\n  color: color(\"black-light\");\n}\n.rating__points-image {\n  height: 1.2rem;\n}\n\n/*# sourceMappingURL=TripAdvisor.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-components/src/components/tripadvisor/TripAdvisor.vue","TripAdvisor.vue"],"names":[],"mappings":"AA0CA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;ACzCA;AD0CA;EACA,sBAAA;EACA,SAAA;EAEA,yBAAA;EACA,qBAAA;EACA,2BAAA;ACzCA;AD2CA;EACA,cAAA;ACzCA;;AAEA,0CAA0C","file":"TripAdvisor.vue","sourcesContent":["<template>\n  <div class=\"rating\">\n          <span class=\"rating__number font-bold\">{{rating}}</span>\n          <img\n            :src=\"getRatingImageForNumber()\"\n            :data-src=\"getRatingImageForNumber()\"\n            :alt=\"getLabel\"\n            class=\"rating__points-image\"\n          />\n          <span class=\"font-bold\">({{getLabel}})</span>\n    </div>\n</template>\n\n<script>\nimport { translate } from 'rhg-vue-common'\n\nexport default {\n  name: 'TripAdvisor',\n  props: {\n    totalReviews: {\n      type: Number,\n      required: true\n    },\n    rating: {\n      type: Number,\n      required: true\n    }\n  },\n  methods: {\n    getRatingImageForNumber() {\n      return `https://www.tripadvisor.com/img/cdsi/img2/ratings/traveler/s${this.rating.toFixed(1)}-MCID-5.svg`\n    }\n  },\n  computed: {\n    getLabel () {\n      return translate('promoReviews', this.totalReviews, this.totalReviews)\n    },}\n\n}\n</script>\n\n<style lang=\"scss\">\n .rating {\n    display: flex;\n    gap: 0.8rem;\n    align-items: center;\n    &__number {\n      padding: 0.4rem 0.8rem;\n      gap: 1rem;\n\n      background-color: #00AA6C;\n      border-radius: 3.9rem;\n      color: color('black-light');\n    }\n    &__points-image {\n      height: 1.2rem;\n    }\n  }\n</style>\n",".rating {\n  display: flex;\n  gap: 0.8rem;\n  align-items: center;\n}\n.rating__number {\n  padding: 0.4rem 0.8rem;\n  gap: 1rem;\n  background-color: #00AA6C;\n  border-radius: 3.9rem;\n  color: color(\"black-light\");\n}\n.rating__points-image {\n  height: 1.2rem;\n}\n\n/*# sourceMappingURL=TripAdvisor.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$8 = undefined;
  /* module identifier */
  const __vue_module_identifier__$8 = undefined;
  /* functional template */
  const __vue_is_functional_template__$8 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$8 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$7 = {
  name: 'HotelCard',
  components: {
    Price: __vue_component__$9,
    Button: __vue_component__$f,
    TripAdvisor: __vue_component__$8
  },
  props: {
    name: {
      type: String,
      required: true
    },
    image: {
      type: String,
      default:
        "https://media.radissonhotels.cn/image/radisson-blu-hotel-chattogram-bay-view/exteriorview/16256-116439-f64873197_3xl.jpg",
    },
    altText: {
      type: String,
      default: "Radisson Hotels",
    },
    distance: {
      type: String,
    },
    code: {
      type: String,
    },
    country: {
      type: String,
    },
    city: {
      type: String,
    },
    formattedAmount: {
      type: String,
    },
    isAvailableHotel: {
      type: Boolean,
    },
    rating: {
      type: Object
    },
    hasGallery: {
      type: Boolean
    }
  },
  computed: {
    getLabel() {
      return this.isAvailableHotel ? translate('promoBook') : translate('promoCheckAvailability')
    },
    getColor() {
      return this.isAvailableHotel ? undefined : 'black'
    },
    isSecondary() {
      return !this.isAvailableHotel
    }
  },
  methods: {
    translate,
    getEvent(hotelCode, hotelName) {
      return this.isAvailableHotel 
        ? this.$emit('onBookNow', hotelCode) 
        : this.$emit('openSBCalendar', { name: hotelName, code: hotelCode })
    },
    onViewGallery(){
      document.querySelector('.image__background').click();
    }
  }
};

/* script */
const __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "card", attrs: { "data-testid": "hotel-card" } },
    [
      _c("div", { staticClass: "image" }, [
        _c("img", {
          staticClass: "image__background",
          attrs: {
            src: _vm.image,
            alt: _vm.altText,
            "data-toggle": _vm.hasGallery && "modal",
            "data-target": "#" + _vm.code,
            "data-slide": "1",
            "data-type-gallery": "overview",
          },
        }),
        _vm._v(" "),
        _vm.hasGallery
          ? _c("i", {
              staticClass:
                "icon-gallery-circle md cursor-pointer image__see-photos-icon",
              on: { click: _vm.onViewGallery },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card__body" },
        [
          _c("div", { staticClass: "card__description" }, [
            _c("span", { staticClass: "card__place" }, [
              _vm._v(_vm._s(_vm.city) + ", " + _vm._s(_vm.country)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "card__hotel-name font-bold" }, [
              _vm._v(_vm._s(_vm.name)),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card__rating" },
              [
                _vm.rating
                  ? _c("TripAdvisor", {
                      attrs: {
                        totalReviews: _vm.rating.reviewCount,
                        rating: _vm.rating.bubbleRating,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "card__distance-from-city-center" }, [
            _vm._v(
              _vm._s(_vm.distance) +
                " " +
                _vm._s(_vm.translate("promoKmFromCityCenter"))
            ),
          ]),
          _vm._v(" "),
          _vm.isAvailableHotel
            ? _c(
                "div",
                [
                  _c("Price", {
                    attrs: {
                      preQtyText: _vm.translate("promoFrom"),
                      quantity: _vm.formattedAmount,
                      postQtyText: _vm.translate("promoNight"),
                    },
                  }),
                ],
                1
              )
            : _c("span", { staticClass: "card__no-availability" }, [
                _vm._v(_vm._s(_vm.translate("promoNoAvailability"))),
              ]),
          _vm._v(" "),
          _c("Button", {
            attrs: {
              id: "book-now-check-availability",
              label: _vm.getLabel,
              secondary: _vm.isSecondary,
              "font-size": "1.3rem",
              big: true,
              color: _vm.getColor,
              "data-testid": "click-button",
            },
            on: {
              click: function ($event) {
                return _vm.getEvent(_vm.code, _vm.name)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
};
var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;

  /* style */
  const __vue_inject_styles__$7 = function (inject) {
    if (!inject) return
    inject("data-v-20dca3a2_0", { source: ".card[data-v-20dca3a2] {\n  width: 32.1rem;\n  border-radius: 0.8rem;\n  border: 0.1rem solid #d8d8d8;\n  color: #242424;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  min-height: 51rem;\n}\n.card .image[data-v-20dca3a2] {\n  width: 100%;\n  height: 18.4rem;\n  position: relative;\n}\n.card .image__background[data-v-20dca3a2] {\n  width: 100%;\n  height: 100%;\n  border-top-left-radius: 0.8rem;\n  border-top-right-radius: 0.8rem;\n}\n.card .image__see-photos-icon[data-v-20dca3a2] {\n  position: absolute;\n  bottom: 1rem;\n  left: 3rem;\n  color: white;\n}\n.card__body[data-v-20dca3a2] {\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n.card__description[data-v-20dca3a2] {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n.card__place[data-v-20dca3a2] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  opacity: 0.5;\n}\n.card__hotel-name[data-v-20dca3a2] {\n  font-size: 2.4rem;\n  line-height: 3rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  min-height: 5.65rem;\n}\n.card__distance-from-city-center[data-v-20dca3a2] {\n  padding: 0.4rem 0.8rem;\n  gap: 1rem;\n  background: #eeeeef;\n  border-radius: 3.5rem;\n  width: fit-content;\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n}\n.card__price[data-v-20dca3a2] {\n  font-size: 2rem;\n  line-height: 2.6rem;\n}\n.card__no-availability[data-v-20dca3a2] {\n  color: #c62525;\n  min-height: 2.6rem;\n}\n.card__rating[data-v-20dca3a2] {\n  min-height: 2.6rem;\n}\n\n/*# sourceMappingURL=HotelCard.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-components/src/components/cards/HotelCard.vue","HotelCard.vue"],"names":[],"mappings":"AAyHA;EACA,cAAA;EACA,qBAAA;EACA,4BAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;ACxHA;ADyHA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;ACvHA;ADwHA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,+BAAA;ACtHA;ADwHA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;ACtHA;ADyHA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;ACvHA;ADyHA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;ACvHA;AD0HA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;ACxHA;AD0HA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,mBAAA;ACxHA;AD0HA;EACA,sBAAA;EACA,SAAA;EAEA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;ACzHA;AD2HA;EACA,eAAA;EACA,mBAAA;ACzHA;AD2HA;EACA,cAAA;EACA,kBAAA;ACzHA;AD2HA;EACA,kBAAA;ACzHA;;AAEA,wCAAwC","file":"HotelCard.vue","sourcesContent":["<template>\n  <div class=\"card\" data-testid=\"hotel-card\">\n    <div class=\"image\">\n      <img\n        class=\"image__background\"\n        :src=\"image\"\n        :alt=\"altText\"\n        :data-toggle=\"hasGallery && 'modal'\"\n        :data-target=\"`#${code}`\"\n        data-slide=\"1\"\n        :data-type-gallery=\"'overview'\"\n      />\n      <i v-if=\"hasGallery\" @click=\"onViewGallery\" class=\"icon-gallery-circle md cursor-pointer image__see-photos-icon\" />\n    </div>\n    <div class=\"card__body\">\n      <div class=\"card__description\">\n        <span class=\"card__place\">{{ city }}, {{ country }}</span>\n        <span class=\"card__hotel-name font-bold\">{{ name }}</span>\n        <div class=\"card__rating\">\n          <TripAdvisor v-if=\"rating\" :totalReviews=\"rating.reviewCount\" :rating=\"rating.bubbleRating\"/>\n        </div>\n      </div>\n      <span class=\"card__distance-from-city-center\"\n        >{{ distance }} {{ translate('promoKmFromCityCenter') }}</span\n      >\n      <div v-if=\"isAvailableHotel\">\n        <Price :preQtyText=\"translate('promoFrom')\" :quantity=\"formattedAmount\" :postQtyText=\"translate('promoNight')\" />\n      </div>\n      <span v-else class=\"card__no-availability\">{{ translate('promoNoAvailability') }}</span>\n      <Button\n        id=\"book-now-check-availability\"\n        :label=\"getLabel\"\n        :secondary=\"isSecondary\"\n        font-size=\"1.3rem\"\n        :big=\"true\"\n        :color=\"getColor\"\n        @click=\"getEvent(code, name)\"\n        data-testid=\"click-button\"/>\n    </div>\n    <slot/>\n  </div>\n</template>\n\n<script>\nimport Price from '../texts/Price.vue';\nimport Button from '../buttons/Button.vue'\nimport TripAdvisor from '../tripadvisor/TripAdvisor.vue'\nimport { translate } from 'rhg-vue-common'\n\nexport default {\n  name: 'HotelCard',\n  components: {\n    Price,\n    Button,\n    TripAdvisor\n  },\n  props: {\n    name: {\n      type: String,\n      required: true\n    },\n    image: {\n      type: String,\n      default:\n        \"https://media.radissonhotels.cn/image/radisson-blu-hotel-chattogram-bay-view/exteriorview/16256-116439-f64873197_3xl.jpg\",\n    },\n    altText: {\n      type: String,\n      default: \"Radisson Hotels\",\n    },\n    distance: {\n      type: String,\n    },\n    code: {\n      type: String,\n    },\n    country: {\n      type: String,\n    },\n    city: {\n      type: String,\n    },\n    formattedAmount: {\n      type: String,\n    },\n    isAvailableHotel: {\n      type: Boolean,\n    },\n    rating: {\n      type: Object\n    },\n    hasGallery: {\n      type: Boolean\n    }\n  },\n  computed: {\n    getLabel() {\n      return this.isAvailableHotel ? translate('promoBook') : translate('promoCheckAvailability')\n    },\n    getColor() {\n      return this.isAvailableHotel ? undefined : 'black'\n    },\n    isSecondary() {\n      return !this.isAvailableHotel\n    }\n  },\n  methods: {\n    translate,\n    getEvent(hotelCode, hotelName) {\n      return this.isAvailableHotel \n        ? this.$emit('onBookNow', hotelCode) \n        : this.$emit('openSBCalendar', { name: hotelName, code: hotelCode })\n    },\n    onViewGallery(){\n      document.querySelector('.image__background').click()\n    }\n  }\n};\n</script>\n\n<style scoped lang=\"scss\">\n.card {\n  width: 32.1rem;\n  border-radius: 0.8rem;\n  border: 0.1rem solid #d8d8d8;\n  color: #242424;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  min-height: 51rem;\n  .image {\n    width: 100%;\n    height: 18.4rem;\n    position: relative;\n    &__background {\n      width: 100%;\n      height: 100%;\n      border-top-left-radius: 0.8rem;\n      border-top-right-radius: 0.8rem;\n    }\n    &__see-photos-icon {\n      position: absolute;\n      bottom: 1rem;\n      left: 3rem;\n      color: white;\n    }\n  }\n  &__body {\n    padding: 2rem;\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n  }\n  &__description {\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n  }\n\n  &__place {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 1.4rem;\n    line-height: 2rem;\n    opacity: 0.5;\n  }\n  &__hotel-name {\n    font-size: 2.4rem;\n    line-height: 3rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    min-height: 5.65rem;\n  }\n  &__distance-from-city-center {\n    padding: 0.4rem 0.8rem;\n    gap: 1rem;\n\n    background: #eeeeef;\n    border-radius: 3.5rem;\n    width: fit-content;\n    font-size: 1.2rem;\n    line-height: 1.6rem;\n  }\n  &__price {\n    font-size: 2rem;\n    line-height: 2.6rem;\n  }\n  &__no-availability {\n    color: #c62525;\n    min-height: 2.6rem;\n  }\n  &__rating {\n    min-height: 2.6rem;\n  }\n}\n</style>\n",".card {\n  width: 32.1rem;\n  border-radius: 0.8rem;\n  border: 0.1rem solid #d8d8d8;\n  color: #242424;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  min-height: 51rem;\n}\n.card .image {\n  width: 100%;\n  height: 18.4rem;\n  position: relative;\n}\n.card .image__background {\n  width: 100%;\n  height: 100%;\n  border-top-left-radius: 0.8rem;\n  border-top-right-radius: 0.8rem;\n}\n.card .image__see-photos-icon {\n  position: absolute;\n  bottom: 1rem;\n  left: 3rem;\n  color: white;\n}\n.card__body {\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n.card__description {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n.card__place {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  opacity: 0.5;\n}\n.card__hotel-name {\n  font-size: 2.4rem;\n  line-height: 3rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  min-height: 5.65rem;\n}\n.card__distance-from-city-center {\n  padding: 0.4rem 0.8rem;\n  gap: 1rem;\n  background: #eeeeef;\n  border-radius: 3.5rem;\n  width: fit-content;\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n}\n.card__price {\n  font-size: 2rem;\n  line-height: 2.6rem;\n}\n.card__no-availability {\n  color: #c62525;\n  min-height: 2.6rem;\n}\n.card__rating {\n  min-height: 2.6rem;\n}\n\n/*# sourceMappingURL=HotelCard.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$7 = "data-v-20dca3a2";
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$7 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$6 = {
  name: 'IconButton',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'submit'
    },
    secondary: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: '#c20808'
    },
    iconName: {
      type: String,
      required: true
    },
    showDot: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getLabel () {
      return translate(this.label) || this.label
    },
    style() {
      return {
        backgroundColor: this.secondary ? '#fff' : this.color,
        border: this.secondary ? '1px solid ' + this.color : 'none'
      };
    },
    textStyle() {
      return {
        color: this.secondary ? this.color : 'white'
      };
    },
    classes() {
      return {
        'button--primary': !this.secondary,
        'button--secondary': this.secondary,
        'loading': this.loading,
      };
    },
  }
};

/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "button",
    {
      staticClass: "button",
      class: _vm.classes,
      style: _vm.style,
      attrs: {
        id: _vm.id,
        "data-testid": _vm.id,
        role: "button",
        type: _vm.type,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("i", {
        staticClass: "xs",
        class: _vm.iconName,
        attrs: { "data-testid": _vm.id + "-icon" },
      }),
      _vm._v(" "),
      _vm.label
        ? _c("span", { staticClass: "button__text", style: _vm.textStyle }, [
            _vm._v(_vm._s(_vm.getLabel)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showDot ? _c("span", { staticClass: "button__dot" }) : _vm._e(),
    ]
  )
};
var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;

  /* style */
  const __vue_inject_styles__$6 = function (inject) {
    if (!inject) return
    inject("data-v-22d0350b_0", { source: ".button[data-v-22d0350b] {\n  padding: 0.8rem 2.5rem;\n  border-radius: 5rem;\n  min-width: 12rem;\n  min-height: 3.6rem;\n}\n.button[data-v-22d0350b]:focus {\n  outline: none;\n}\n.button__text[data-v-22d0350b] {\n  font-weight: normal;\n  font-size: 1.6rem;\n  text-transform: initial;\n}\n.button__dot[data-v-22d0350b] {\n  height: 0.5rem;\n  width: 0.5rem;\n  background-color: #c62525;\n  border-radius: 50%;\n  display: inline-block;\n  margin-left: 0.5rem;\n  margin-bottom: 0.2rem;\n}\n\n/*# sourceMappingURL=IconButton.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-components/src/components/buttons/IconButton.vue","IconButton.vue"],"names":[],"mappings":"AAuEA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;ACtEA;ADwEA;EACA,aAAA;ACtEA;ADyEA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;ACvEA;AD0EA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;ACxEA;;AAEA,yCAAyC","file":"IconButton.vue","sourcesContent":["<template>\n  <button :id=\"id\" :data-testid=\"id\" role=\"button\" :type=\"type\" class=\"button\" :class=\"classes\"\n          :style=\"style\" @click=\"$emit('click')\" >\n    <i :data-testid=\"id + '-icon'\" class=\"xs\" :class=\"iconName\"></i>\n    <span v-if=\"label\" class=\"button__text\" :style=\"textStyle\" >{{ getLabel }}</span>\n    <span v-if=\"showDot\" class=\"button__dot\"/>\n  </button>\n</template>\n\n<script>\nimport { translate } from 'rhg-vue-common'\n\nexport default {\n  name: 'IconButton',\n  props: {\n    id: {\n      type: String,\n      required: true\n    },\n    label: {\n      type: String,\n      required: true\n    },\n    type: {\n      type: String,\n      default: 'submit'\n    },\n    secondary: {\n      type: Boolean,\n      default: false\n    },\n    color: {\n      type: String,\n      default: '#c20808'\n    },\n    iconName: {\n      type: String,\n      required: true\n    },\n    showDot: {\n      type: Boolean,\n      default: false\n    }\n  },\n  computed: {\n    getLabel () {\n      return translate(this.label) || this.label\n    },\n    style() {\n      return {\n        backgroundColor: this.secondary ? '#fff' : this.color,\n        border: this.secondary ? '1px solid ' + this.color : 'none'\n      };\n    },\n    textStyle() {\n      return {\n        color: this.secondary ? this.color : 'white'\n      };\n    },\n    classes() {\n      return {\n        'button--primary': !this.secondary,\n        'button--secondary': this.secondary,\n        'loading': this.loading,\n      };\n    },\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n.button {\n  padding: .8rem 2.5rem;\n  border-radius: 5rem;\n  min-width: 12rem;\n  min-height: 3.6rem;\n\n  &:focus {\n    outline: none;\n  }\n\n  &__text {\n    font-weight: normal;\n    font-size: 1.6rem;\n    text-transform: initial;\n  }\n\n  &__dot {\n    height: 0.5rem;\n    width: 0.5rem;\n    background-color: #c62525;\n    border-radius: 50%;\n    display: inline-block;\n    margin-left: 0.5rem;\n    margin-bottom: 0.2rem;\n  }\n}\n</style>\n",".button {\n  padding: 0.8rem 2.5rem;\n  border-radius: 5rem;\n  min-width: 12rem;\n  min-height: 3.6rem;\n}\n.button:focus {\n  outline: none;\n}\n.button__text {\n  font-weight: normal;\n  font-size: 1.6rem;\n  text-transform: initial;\n}\n.button__dot {\n  height: 0.5rem;\n  width: 0.5rem;\n  background-color: #c62525;\n  border-radius: 50%;\n  display: inline-block;\n  margin-left: 0.5rem;\n  margin-bottom: 0.2rem;\n}\n\n/*# sourceMappingURL=IconButton.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$6 = "data-v-22d0350b";
  /* module identifier */
  const __vue_module_identifier__$6 = undefined;
  /* functional template */
  const __vue_is_functional_template__$6 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$6 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    false,
    createInjector,
    undefined,
    undefined
  );

//
//
//
//


var script$5 = {
  name: 'Icon',
  props: {
    name: {
      type: String,
      default: 'icon-arrow-right'
    },
    size: {
      type: String,
      default: 'xs'
    },
    color: {
      type: String,
      default: 'black'
    }
  },
  computed: {
    getClasses() {
      return `${this.name} ${this.size} color-${ this.color}`;
    },
  }
};

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("i", { class: _vm.getClasses, attrs: { "data-testid": _vm.name } })
};
var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;

  /* style */
  const __vue_inject_styles__$5 = undefined;
  /* scoped */
  const __vue_scope_id__$5 = undefined;
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$5 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$4 = {
  name: 'Link',
  props: {
    id: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    modal: {
      type: String
    },
    size: {
      type: String,
      default: '1.2rem'
    }
  },
  computed: {
    getLabel () {
      return translate(this.label) || this.label
    },
    style() {
      return {
        fontSize: this.size
      };
    },
  }
};

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "b-button",
    {
      directives: [
        {
          name: "b-modal",
          rawName: "v-b-modal",
          value: _vm.modal,
          expression: "modal",
        },
      ],
      attrs: {
        id: _vm.id,
        "data-testid": _vm.id,
        disabled: _vm.disabled,
        variant: "link",
      },
    },
    [
      _c("span", { staticClass: "link__text", style: _vm.style }, [
        _vm._v(_vm._s(_vm.getLabel)),
      ]),
    ]
  )
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = function (inject) {
    if (!inject) return
    inject("data-v-48aaa202_0", { source: ".link__text[data-v-48aaa202] {\n  color: #c20808;\n  font-weight: bold;\n  text-decoration: underline;\n}\n\n/*# sourceMappingURL=Link.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-components/src/components/links/Link.vue","Link.vue"],"names":[],"mappings":"AA8CA;EACA,cAAA;EACA,iBAAA;EACA,0BAAA;AC7CA;;AAEA,mCAAmC","file":"Link.vue","sourcesContent":["<template>\n  <b-button :id=\"id\" :data-testid=\"id\" :disabled=\"disabled\" variant=\"link\" v-b-modal=\"modal\">\n    <span :style=\"style\" class=\"link__text\">{{ getLabel }}</span>\n  </b-button>\n</template>\n\n<script>\nimport { translate } from 'rhg-vue-common'\n\nexport default {\n  name: 'Link',\n  props: {\n    id: {\n      type: String,\n      required: true\n    },\n    disabled: {\n      type: Boolean,\n      default: false\n    },\n    label: {\n      type: String\n    },\n    modal: {\n      type: String\n    },\n    size: {\n      type: String,\n      default: '1.2rem'\n    }\n  },\n  computed: {\n    getLabel () {\n      return translate(this.label) || this.label\n    },\n    style() {\n      return {\n        fontSize: this.size\n      };\n    },\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n.link {\n  &__text {\n    color: #c20808;\n    font-weight: bold;\n    text-decoration: underline;\n  }\n}\n</style>\n",".link__text {\n  color: #c20808;\n  font-weight: bold;\n  text-decoration: underline;\n}\n\n/*# sourceMappingURL=Link.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$4 = "data-v-48aaa202";
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$4 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$3 = {
  name: 'Link',
  components: {
    Icon: __vue_component__$5
  },
  props: {
    id: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    size: {
      type: String,
      default: '1.2rem'
    },
    underline: {
      type: Boolean,
      default: true
    },
    uppercase: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: '#c20808'
    },
    iconColor: {
      type: String,
      default: 'primary'
    },
    iconName: {
      type: String,
      default: 'icon-arrow-left-nlp'
    }
  },
  computed: {
    getLabel () {
      return translate(this.label) || this.label
    },
    style() {
      return {
        fontSize: this.size,
        color: this.color,
        textDecoration: this.underline ? 'underline' : 'none',
        textTransform: this.uppercase ? 'uppercase' : 'none'
      };
    }
  }
};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "b-button",
    {
      staticClass: "link",
      attrs: {
        id: _vm.id,
        "data-testid": _vm.id,
        disabled: _vm.disabled,
        variant: "link",
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("Icon", { attrs: { name: _vm.iconName, color: _vm.iconColor } }),
      _vm._v(" "),
      _c("span", { staticClass: "link__text", style: _vm.style }, [
        _vm._v(_vm._s(_vm.getLabel)),
      ]),
    ],
    1
  )
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = function (inject) {
    if (!inject) return
    inject("data-v-5e5272bc_0", { source: ".link[data-v-5e5272bc] {\n  cursor: pointer;\n}\n.link__text[data-v-5e5272bc] {\n  font-weight: bold;\n}\n\n/*# sourceMappingURL=LinkLeftIcon.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-components/src/components/links/LinkLeftIcon.vue","LinkLeftIcon.vue"],"names":[],"mappings":"AAsEA;EACA,eAAA;ACrEA;ADsEA;EACA,iBAAA;ACpEA;;AAEA,2CAA2C","file":"LinkLeftIcon.vue","sourcesContent":["<template>\n  <b-button class=\"link\" :id=\"id\" :data-testid=\"id\" :disabled=\"disabled\" variant=\"link\" @click=\"$emit('click')\">\n    <Icon :name=\"iconName\" :color=\"iconColor\"/>\n    <span :style=\"style\" class=\"link__text\">{{ getLabel }}</span>\n  </b-button>\n</template>\n\n<script>\nimport { translate } from 'rhg-vue-common'\nimport Icon from '../icons/Icon.vue'\n\nexport default {\n  name: 'Link',\n  components: {\n    Icon\n  },\n  props: {\n    id: {\n      type: String,\n      required: true\n    },\n    disabled: {\n      type: Boolean,\n      default: false\n    },\n    label: {\n      type: String\n    },\n    size: {\n      type: String,\n      default: '1.2rem'\n    },\n    underline: {\n      type: Boolean,\n      default: true\n    },\n    uppercase: {\n      type: Boolean,\n      default: false\n    },\n    color: {\n      type: String,\n      default: '#c20808'\n    },\n    iconColor: {\n      type: String,\n      default: 'primary'\n    },\n    iconName: {\n      type: String,\n      default: 'icon-arrow-left-nlp'\n    }\n  },\n  computed: {\n    getLabel () {\n      return translate(this.label) || this.label\n    },\n    style() {\n      return {\n        fontSize: this.size,\n        color: this.color,\n        textDecoration: this.underline ? 'underline' : 'none',\n        textTransform: this.uppercase ? 'uppercase' : 'none'\n      };\n    }\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n.link {\n  cursor: pointer;\n  &__text {\n    font-weight: bold;\n  }\n}\n</style>\n",".link {\n  cursor: pointer;\n}\n.link__text {\n  font-weight: bold;\n}\n\n/*# sourceMappingURL=LinkLeftIcon.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$3 = "data-v-5e5272bc";
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$2 = {
  name: 'LinkRightIcon',
  components: {
    Icon: __vue_component__$5
  },
  props: {
    id: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    link: {
      type: Object,
      default: () => ({})
    },
    size: {
      type: String,
      default: '1.2rem'
    },
    underline: {
      type: Boolean,
      default: true
    },
    uppercase: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: '#c20808'
    },
    iconColor: {
      type: String,
      default: 'primary'
    },
    iconName: {
      type: String,
      default: 'icon-arrow-right-nlp'
    }
  },
  computed: {
    tagType () {
      return this.link.href ? 'a' : 'button'
    },
    getLabel () {
      return translate(this.label) || this.label
    },
    style() {
      return {
        fontSize: this.size,
        color: this.color,
        textDecoration: this.underline ? 'underline' : 'none',
        textTransform: this.uppercase ? 'uppercase' : 'none'
      };
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    _vm.tagType,
    {
      tag: "component",
      staticClass: "link",
      attrs: {
        id: _vm.id,
        "data-testid": _vm.id,
        disabled: _vm.disabled,
        href: _vm.link.href,
        variant: "link",
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("span", { staticClass: "link__text", style: _vm.style }, [
        _vm._v(_vm._s(_vm.getLabel)),
      ]),
      _vm._v(" "),
      _c("Icon", { attrs: { name: _vm.iconName, color: _vm.iconColor } }),
    ],
    1
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = function (inject) {
    if (!inject) return
    inject("data-v-4396c9cd_0", { source: ".link[data-v-4396c9cd] {\n  cursor: pointer;\n  background: inherit;\n  border: 0;\n  padding: 0;\n  text-align: left;\n}\n.link[data-v-4396c9cd]:focus {\n  box-shadow: none;\n}\n.link__text[data-v-4396c9cd] {\n  font-weight: bold;\n}\n\n/*# sourceMappingURL=LinkRightIcon.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-components/src/components/links/LinkRightIcon.vue","LinkRightIcon.vue"],"names":[],"mappings":"AAsFA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;ACrFA;ADuFA;EACA,gBAAA;ACrFA;ADwFA;EACA,iBAAA;ACtFA;;AAEA,4CAA4C","file":"LinkRightIcon.vue","sourcesContent":["<template>\n  <component\n    :is=\"tagType\"\n    class=\"link\"\n    :id=\"id\"\n    :data-testid=\"id\"\n    :disabled=\"disabled\"\n    :href=\"link.href\"\n    variant=\"link\"\n    @click=\"$emit('click')\"\n  >\n    <span :style=\"style\" class=\"link__text\">{{ getLabel }}</span>\n    <Icon :name=\"iconName\" :color=\"iconColor\"/>\n  </component>\n</template>\n\n<script>\nimport { translate } from 'rhg-vue-common'\nimport Icon from '../icons/Icon.vue'\n\nexport default {\n  name: 'LinkRightIcon',\n  components: {\n    Icon\n  },\n  props: {\n    id: {\n      type: String,\n      required: true\n    },\n    disabled: {\n      type: Boolean,\n      default: false\n    },\n    label: {\n      type: String\n    },\n    link: {\n      type: Object,\n      default: () => ({})\n    },\n    size: {\n      type: String,\n      default: '1.2rem'\n    },\n    underline: {\n      type: Boolean,\n      default: true\n    },\n    uppercase: {\n      type: Boolean,\n      default: false\n    },\n    color: {\n      type: String,\n      default: '#c20808'\n    },\n    iconColor: {\n      type: String,\n      default: 'primary'\n    },\n    iconName: {\n      type: String,\n      default: 'icon-arrow-right-nlp'\n    }\n  },\n  computed: {\n    tagType () {\n      return this.link.href ? 'a' : 'button'\n    },\n    getLabel () {\n      return translate(this.label) || this.label\n    },\n    style() {\n      return {\n        fontSize: this.size,\n        color: this.color,\n        textDecoration: this.underline ? 'underline' : 'none',\n        textTransform: this.uppercase ? 'uppercase' : 'none'\n      };\n    }\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n.link {\n  cursor: pointer;\n  background: inherit;\n  border: 0;\n  padding: 0;\n  text-align: left;\n\n  &:focus {\n    box-shadow: none;\n  }\n\n  &__text {\n    font-weight: bold;\n  }\n}\n</style>\n",".link {\n  cursor: pointer;\n  background: inherit;\n  border: 0;\n  padding: 0;\n  text-align: left;\n}\n.link:focus {\n  box-shadow: none;\n}\n.link__text {\n  font-weight: bold;\n}\n\n/*# sourceMappingURL=LinkRightIcon.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$2 = "data-v-4396c9cd";
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$1 = {
  name: 'OfferCard',
  components: {
    Button: __vue_component__$f,
    Badge: __vue_component__$g,
    ExpirationBadge: __vue_component__$c
  },
  props: {
    badgeText: {
      type: String
    },
    expiration: {
      type: Object
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    image: {
      type: Object,
      required: true
    },
    buttonPrimary: {
      type: Object,
      default: () => ({})
    },
    buttonSecondary: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    translate,
    handle (callback) {
      typeof callback === 'function' && callback();
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("article", { staticClass: "offer-card" }, [
    _c("figure", { staticClass: "offer-card__header" }, [
      _c("img", {
        staticClass: "offer-card__img",
        attrs: { src: _vm.image.src, alt: _vm.image.alt },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "offer-card__main" }, [
      _c("div", { staticClass: "offer-card__content" }, [
        _c(
          "div",
          { staticClass: "offer-card__pre-title" },
          [
            _c("ExpirationBadge", {
              attrs: {
                text: _vm.expiration.text,
                expired: _vm.expiration.expiresSoon,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.badgeText
          ? _c(
              "div",
              { staticClass: "offer-card__badges" },
              [_c("Badge", { attrs: { text: _vm.badgeText } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("h3", { staticClass: "offer-card__title" }, [
          _vm._v("\n        " + _vm._s(_vm.title) + "\n      "),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "offer-card__description color-dark-grey" }, [
          _vm._v("\n        " + _vm._s(_vm.description) + "\n      "),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "offer-card__footer" },
        [
          Object.keys(_vm.buttonPrimary).length
            ? _c("Button", {
                attrs: {
                  id: _vm.buttonPrimary.id,
                  "data-testid": _vm.buttonPrimary.id,
                  link: _vm.buttonPrimary.link,
                  label: _vm.buttonPrimary.label,
                  "font-size": "1.6rem",
                  big: true,
                },
                on: {
                  click: function ($event) {
                    return _vm.handle(_vm.buttonPrimary.callback)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          Object.keys(_vm.buttonSecondary).length
            ? _c("Button", {
                attrs: {
                  id: _vm.buttonSecondary.id,
                  "data-testid": _vm.buttonSecondary.id,
                  link: _vm.buttonSecondary.link,
                  label: _vm.buttonSecondary.label,
                  "font-size": "1.6rem",
                  secondary: "",
                  big: true,
                  color: "black",
                },
                on: {
                  click: function ($event) {
                    return _vm.handle(_vm.buttonSecondary.callback)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = function (inject) {
    if (!inject) return
    inject("data-v-a94f927e_0", { source: ".offer-card[data-v-a94f927e] {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  border-radius: 0.8rem;\n}\n@media (min-width: 768px) {\n.offer-card[data-v-a94f927e] {\n    flex-direction: row;\n}\n}\n.offer-card__header[data-v-a94f927e] {\n  position: relative;\n  width: 100%;\n  height: 15rem;\n}\n@media (min-width: 768px) {\n.offer-card__header[data-v-a94f927e] {\n    min-width: 25rem;\n    max-width: 25rem;\n    height: auto;\n}\n}\n.offer-card__img[data-v-a94f927e] {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.offer-card__badges[data-v-a94f927e] {\n  position: absolute;\n  inset: 2.4rem auto auto 2.4rem;\n}\n@media (min-width: 768px) {\n.offer-card__badges[data-v-a94f927e] {\n    position: relative;\n    inset: auto;\n    margin-bottom: 0.5rem;\n}\n}\n.offer-card__main[data-v-a94f927e] {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: space-between;\n}\n@media (min-width: 768px) {\n.offer-card__main[data-v-a94f927e] {\n    flex-direction: row;\n}\n}\n.offer-card__content[data-v-a94f927e], .offer-card__footer[data-v-a94f927e] {\n  background: #fff;\n}\n.offer-card__content[data-v-a94f927e] {\n  width: 100%;\n  padding: 2.6rem 2.4rem 2.4rem 2.4rem;\n}\n@media (min-width: 768px) {\n.offer-card__content[data-v-a94f927e] {\n    flex-direction: row;\n    padding: 3rem 1.5rem 3rem 2.4rem;\n}\n}\n@media (min-width: 992px) {\n.offer-card__content[data-v-a94f927e] {\n    padding: 3rem 3rem 3rem 4.8rem;\n}\n}\n.offer-card__title[data-v-a94f927e] {\n  font-style: normal;\n  font-weight: 300;\n  font-size: 2rem;\n  line-height: 2.6rem;\n  margin-bottom: 0.8rem;\n}\n@media (min-width: 768px) {\n.offer-card__title[data-v-a94f927e] {\n    margin-bottom: 1.2rem;\n    font-size: 2.4rem;\n    line-height: 3rem;\n}\n}\n.offer-card__description[data-v-a94f927e] {\n  font-weight: 400;\n  font-size: 1.6rem;\n  margin-bottom: 0;\n}\n.offer-card__footer[data-v-a94f927e] {\n  display: flex;\n  flex-direction: column;\n  gap: 1.6rem;\n  padding: 0 2.4rem 2.4rem 2.4rem;\n}\n@media (min-width: 768px) {\n.offer-card__footer[data-v-a94f927e] {\n    justify-content: center;\n    min-width: 19.5rem;\n    padding: 3rem 2.4rem;\n    margin-left: 1px;\n}\n}\n@media (min-width: 992px) {\n.offer-card__footer[data-v-a94f927e] {\n    min-width: 25rem;\n    padding: 3rem 4.8rem;\n    margin-left: 1px;\n}\n}\n\n/*# sourceMappingURL=OfferCard.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-components/src/components/cards/OfferCard.vue","OfferCard.vue"],"names":[],"mappings":"AA0GA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;ACzGA;AD2GA;AAPA;IAQA,mBAAA;ACxGE;AACF;AD0GA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;ACxGA;AD0GA;AALA;IAMA,gBAAA;IACA,gBAAA;IACA,YAAA;ACvGE;AACF;AD0GA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;ACxGA;AD2GA;EACA,kBAAA;EACA,8BAAA;ACzGA;AD2GA;AAJA;IAKA,kBAAA;IACA,WAAA;IACA,qBAAA;ACxGE;AACF;AD2GA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;ACzGA;AD2GA;AANA;IAOA,mBAAA;ACxGE;AACF;AD2GA;EACA,gBAAA;ACzGA;AD4GA;EACA,WAAA;EACA,oCAAA;AC1GA;AD4GA;AAJA;IAKA,mBAAA;IACA,gCAAA;ACzGE;AACF;AD0GA;AARA;IASA,8BAAA;ACvGE;AACF;AD0GA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;ACxGA;AD0GA;AAPA;IAQA,qBAAA;IACA,iBAAA;IACA,iBAAA;ACvGE;AACF;AD0GA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;ACxGA;AD2GA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,+BAAA;ACzGA;AD2GA;AANA;IAOA,uBAAA;IACA,kBAAA;IACA,oBAAA;IACA,gBAAA;ACxGE;AACF;ADyGA;AAZA;IAaA,gBAAA;IACA,oBAAA;IACA,gBAAA;ACtGE;AACF;;AAEA,wCAAwC","file":"OfferCard.vue","sourcesContent":["<template>\n  <article class=\"offer-card\">\n    <figure class=\"offer-card__header\">\n      <img class=\"offer-card__img\" :src=\"image.src\" :alt=\"image.alt\">\n    </figure>\n\n    <div class=\"offer-card__main\">\n      <div class=\"offer-card__content\">\n        <div class=\"offer-card__pre-title\">\n          <ExpirationBadge\n            :text=\"expiration.text\"\n            :expired=\"expiration.expiresSoon\"\n          />\n        </div>\n\n        <div class=\"offer-card__badges\" v-if=\"badgeText\">\n          <Badge :text=\"badgeText\"/>\n        </div>\n\n        <h3 class=\"offer-card__title\">\n          {{ title }}\n        </h3>\n\n        <p class=\"offer-card__description color-dark-grey\">\n          {{ description }}\n        </p>\n      </div>\n\n      <div class=\"offer-card__footer\">\n        <Button\n          v-if=\"Object.keys(buttonPrimary).length\"\n          :id=\"buttonPrimary.id\"\n          :data-testid=\"buttonPrimary.id\"\n          :link=\"buttonPrimary.link\"\n          :label=\"buttonPrimary.label\"\n          font-size=\"1.6rem\"\n          :big=\"true\"\n          @click=\"handle(buttonPrimary.callback)\" \n        />\n        <Button\n          v-if=\"Object.keys(buttonSecondary).length\"\n          :id=\"buttonSecondary.id\"\n          :data-testid=\"buttonSecondary.id\"\n          :link=\"buttonSecondary.link\"\n          :label=\"buttonSecondary.label\"\n          font-size=\"1.6rem\"\n          secondary\n          :big=\"true\"\n          color=\"black\"\n          @click=\"handle(buttonSecondary.callback)\"\n        />\n      </div>\n    </div>\n  </article>\n</template>\n\n<script>\nimport Button from '../buttons/Button.vue'\nimport Badge from '../badges/Badge.vue'\nimport ExpirationBadge from '../badges/ExpirationBadge.vue'\nimport { translate } from 'rhg-vue-common'\n\nexport default {\n  name: 'OfferCard',\n  components: {\n    Button,\n    Badge,\n    ExpirationBadge\n  },\n  props: {\n    badgeText: {\n      type: String\n    },\n    expiration: {\n      type: Object\n    },\n    title: {\n      type: String,\n      required: true\n    },\n    description: {\n      type: String\n    },\n    image: {\n      type: Object,\n      required: true\n    },\n    buttonPrimary: {\n      type: Object,\n      default: () => ({})\n    },\n    buttonSecondary: {\n      type: Object,\n      default: () => ({})\n    }\n  },\n  methods: {\n    translate,\n    handle (callback) {\n      typeof callback === 'function' && callback()\n    }\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n.offer-card {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  border-radius: .8rem;\n\n  @media (min-width: 768px) {\n    flex-direction: row;\n  }\n\n  &__header {\n    position: relative;\n    width: 100%;\n    height: 15rem;\n\n    @media (min-width: 768px) {\n      min-width: 25rem;\n      max-width: 25rem;\n      height: auto;\n    }\n  }\n\n  &__img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  &__badges {\n    position: absolute;\n    inset: 2.4rem auto auto 2.4rem;\n\n    @media (min-width: 768px) {\n      position: relative;\n      inset: auto;\n      margin-bottom: .5rem;\n    }\n  }\n\n  &__main {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    justify-content: space-between;\n\n    @media (min-width: 768px) {\n      flex-direction: row;\n    }\n  }\n\n  &__content, &__footer {\n    background: #fff;\n  }\n\n  &__content {\n    width: 100%;\n    padding: 2.6rem 2.4rem 2.4rem 2.4rem;\n\n    @media (min-width: 768px) {\n      flex-direction: row;\n      padding: 3rem 1.5rem 3rem 2.4rem;\n    }\n    @media (min-width: 992px) {\n      padding: 3rem 3rem 3rem 4.8rem;\n    }\n  }\n\n  &__title {\n    font-style: normal;\n    font-weight: 300;\n    font-size: 2rem;\n    line-height: 2.6rem;\n    margin-bottom: .8rem;\n\n    @media (min-width: 768px) {\n      margin-bottom: 1.2rem;\n      font-size: 2.4rem;\n      line-height: 3rem;\n    }\n  }\n\n  &__description {\n    font-weight: 400;\n    font-size: 1.6rem;\n    margin-bottom: 0;\n  }\n\n  &__footer {\n    display: flex;\n    flex-direction: column;\n    gap: 1.6rem;\n    padding: 0 2.4rem 2.4rem 2.4rem;\n\n    @media (min-width: 768px) {\n      justify-content: center;\n      min-width: 19.5rem;\n      padding: 3rem 2.4rem;\n      margin-left: 1px;\n    }\n    @media (min-width: 992px) {\n      min-width: 25rem;\n      padding: 3rem 4.8rem;\n      margin-left: 1px;\n    }\n  }\n}\n\n</style>",".offer-card {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  border-radius: 0.8rem;\n}\n@media (min-width: 768px) {\n  .offer-card {\n    flex-direction: row;\n  }\n}\n.offer-card__header {\n  position: relative;\n  width: 100%;\n  height: 15rem;\n}\n@media (min-width: 768px) {\n  .offer-card__header {\n    min-width: 25rem;\n    max-width: 25rem;\n    height: auto;\n  }\n}\n.offer-card__img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.offer-card__badges {\n  position: absolute;\n  inset: 2.4rem auto auto 2.4rem;\n}\n@media (min-width: 768px) {\n  .offer-card__badges {\n    position: relative;\n    inset: auto;\n    margin-bottom: 0.5rem;\n  }\n}\n.offer-card__main {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: space-between;\n}\n@media (min-width: 768px) {\n  .offer-card__main {\n    flex-direction: row;\n  }\n}\n.offer-card__content, .offer-card__footer {\n  background: #fff;\n}\n.offer-card__content {\n  width: 100%;\n  padding: 2.6rem 2.4rem 2.4rem 2.4rem;\n}\n@media (min-width: 768px) {\n  .offer-card__content {\n    flex-direction: row;\n    padding: 3rem 1.5rem 3rem 2.4rem;\n  }\n}\n@media (min-width: 992px) {\n  .offer-card__content {\n    padding: 3rem 3rem 3rem 4.8rem;\n  }\n}\n.offer-card__title {\n  font-style: normal;\n  font-weight: 300;\n  font-size: 2rem;\n  line-height: 2.6rem;\n  margin-bottom: 0.8rem;\n}\n@media (min-width: 768px) {\n  .offer-card__title {\n    margin-bottom: 1.2rem;\n    font-size: 2.4rem;\n    line-height: 3rem;\n  }\n}\n.offer-card__description {\n  font-weight: 400;\n  font-size: 1.6rem;\n  margin-bottom: 0;\n}\n.offer-card__footer {\n  display: flex;\n  flex-direction: column;\n  gap: 1.6rem;\n  padding: 0 2.4rem 2.4rem 2.4rem;\n}\n@media (min-width: 768px) {\n  .offer-card__footer {\n    justify-content: center;\n    min-width: 19.5rem;\n    padding: 3rem 2.4rem;\n    margin-left: 1px;\n  }\n}\n@media (min-width: 992px) {\n  .offer-card__footer {\n    min-width: 25rem;\n    padding: 3rem 4.8rem;\n    margin-left: 1px;\n  }\n}\n\n/*# sourceMappingURL=OfferCard.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$1 = "data-v-a94f927e";
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script = {
  name: 'ShortOfferCard',
  components: {
    IconLink: __vue_component__$2,
    Button: __vue_component__$f,
    Badge: __vue_component__$g,
    ExpirationBadge: __vue_component__$c
  },
  props: {
    badgeText: {
      type: String
    },
    expiration: {
      type: Object
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    image: {
      type: Object,
      required: true
    },
    buttonPrimary: {
      type: Object,
      default: () => ({})
    },
    buttonSecondary: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    translate,
    handle (callback) {
      typeof callback === 'function' && callback();
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "article",
    { staticClass: "offer-card" },
    [
      _c(
        "div",
        { staticClass: "offer-card__main" },
        [
          _c(
            "div",
            { staticClass: "offer-card__pre-title" },
            [
              _c("ExpirationBadge", {
                attrs: {
                  text: _vm.expiration.text,
                  expired: _vm.expiration.expiresSoon,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.badgeText
            ? _c(
                "div",
                { staticClass: "offer-card__badges" },
                [_c("Badge", { attrs: { text: _vm.badgeText } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("h3", { staticClass: "offer-card__title" }, [
            _vm._v(_vm._s(_vm.title) + " "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "offer-card__description color-dark-grey" }, [
            _vm._v(_vm._s(_vm.description)),
          ]),
          _vm._v(" "),
          Object.keys(_vm.buttonSecondary).length
            ? _c("IconLink", {
                staticClass: "offer-card__link",
                attrs: {
                  id: _vm.buttonSecondary.id,
                  link: _vm.buttonSecondary.link,
                  label: _vm.buttonSecondary.label,
                  size: "1.6rem",
                  underline: false,
                  uppercase: "",
                },
                on: {
                  click: function ($event) {
                    return _vm.handle(_vm.buttonSecondary.callback)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      Object.keys(_vm.buttonPrimary).length
        ? _c("Button", {
            staticClass: "offer-card__book",
            attrs: {
              id: _vm.buttonPrimary.id,
              "data-testid": _vm.buttonPrimary.id,
              link: _vm.buttonPrimary.link,
              label: _vm.buttonPrimary.label,
              "font-size": "1.6rem",
              big: true,
            },
            on: {
              click: function ($event) {
                return _vm.handle(_vm.buttonPrimary.callback)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("figure", { staticClass: "offer-card__img-container" }, [
        _c("img", {
          staticClass: "offer-card__img",
          attrs: { src: _vm.image.src, alt: _vm.image.alt },
        }),
      ]),
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-18b6eb81_0", { source: ".offer-card[data-v-18b6eb81] {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  border-radius: 0.8rem;\n}\n@media (min-width: 768px) {\n.offer-card[data-v-18b6eb81] {\n    flex-direction: row;\n}\n}\n.offer-card__main[data-v-18b6eb81] {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background: #fff;\n  width: 100%;\n  padding: 2.4rem;\n}\n@media (min-width: 768px) {\n.offer-card__main[data-v-18b6eb81] {\n    flex-direction: column;\n}\n}\n@media (min-width: 768px) {\n.offer-card__badges[data-v-18b6eb81] {\n    position: relative;\n    inset: auto;\n    margin-bottom: 0.5rem;\n}\n}\n.offer-card__title[data-v-18b6eb81] {\n  font-style: normal;\n  font-weight: 300;\n  font-size: 2rem;\n  line-height: 2.6rem;\n  margin-bottom: 0.8rem;\n}\n@media (min-width: 768px) {\n.offer-card__title[data-v-18b6eb81] {\n    margin-bottom: 1.2rem;\n    font-size: 2.4rem;\n    line-height: 3rem;\n}\n}\n.offer-card__description[data-v-18b6eb81] {\n  font-weight: 400;\n  font-size: 1.6rem;\n  margin-bottom: 0;\n}\n.offer-card__link[data-v-18b6eb81] {\n  text-transform: uppercase;\n  text-decoration: none;\n  margin-top: 1rem;\n}\n@media (min-width: 768px) {\n.offer-card__link[data-v-18b6eb81] {\n    max-width: 25rem;\n    height: auto;\n}\n}\n.offer-card__img-container[data-v-18b6eb81] {\n  position: relative;\n  width: 100%;\n  height: 20rem;\n}\n@media (min-width: 768px) {\n.offer-card__img-container[data-v-18b6eb81] {\n    max-width: 25rem;\n    height: auto;\n}\n}\n.offer-card__img[data-v-18b6eb81] {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.offer-card__book[data-v-18b6eb81] {\n  position: absolute;\n  bottom: 2rem;\n  right: 2rem;\n  z-index: 1;\n}\n\n/*# sourceMappingURL=ShortOfferCard.vue.map */", map: {"version":3,"sources":["/builds/gitlab/front-end/vue-common/packages/rhg-vue-components/src/components/cards/ShortOfferCard.vue","ShortOfferCard.vue"],"names":[],"mappings":"AAkGA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;ACjGA;ADmGA;AAPA;IAQA,mBAAA;AChGE;AACF;ADkGA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AChGA;ADkGA;AARA;IASA,sBAAA;AC/FE;AACF;ADmGA;AADA;IAEA,kBAAA;IACA,WAAA;IACA,qBAAA;AChGE;AACF;ADmGA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;ACjGA;ADmGA;AAPA;IAQA,qBAAA;IACA,iBAAA;IACA,iBAAA;AChGE;AACF;ADmGA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;ACjGA;ADoGA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AClGA;ADoGA;AALA;IAMA,gBAAA;IACA,YAAA;ACjGE;AACF;ADoGA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AClGA;ADoGA;AALA;IAMA,gBAAA;IACA,YAAA;ACjGE;AACF;ADoGA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AClGA;ADqGA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;ACnGA;;AAEA,6CAA6C","file":"ShortOfferCard.vue","sourcesContent":["<template>\n  <article class=\"offer-card\">\n    <div class=\"offer-card__main\">\n      <div class=\"offer-card__pre-title\">\n        <ExpirationBadge\n          :text=\"expiration.text\"\n          :expired=\"expiration.expiresSoon\"\n        />\n      </div>\n\n      <div class=\"offer-card__badges\" v-if=\"badgeText\">\n        <Badge :text=\"badgeText\"/>\n      </div>\n\n      <h3 class=\"offer-card__title\">{{ title }} </h3>\n      <p class=\"offer-card__description color-dark-grey\">{{ description }}</p>\n\n      <IconLink\n        v-if=\"Object.keys(buttonSecondary).length\"\n        :id=\"buttonSecondary.id\"\n        class=\"offer-card__link\"\n        :link=\"buttonSecondary.link\"\n        :label=\"buttonSecondary.label\"\n        size=\"1.6rem\"\n        :underline=\"false\"\n        uppercase\n        @click=\"handle(buttonSecondary.callback)\"\n      />\n    </div>\n    <Button\n      v-if=\"Object.keys(buttonPrimary).length\"\n      class=\"offer-card__book\"\n      :id=\"buttonPrimary.id\"\n      :data-testid=\"buttonPrimary.id\"\n      :link=\"buttonPrimary.link\"\n      :label=\"buttonPrimary.label\"\n      font-size=\"1.6rem\"\n      :big=\"true\"\n      @click=\"handle(buttonPrimary.callback)\"\n    />\n    <figure class=\"offer-card__img-container\">\n      <img class=\"offer-card__img\" :src=\"image.src\" :alt=\"image.alt\">\n    </figure>\n  </article>\n</template>\n\n<script>\nimport Button from '../buttons/Button.vue'\nimport IconLink from '../links/LinkRightIcon.vue'\nimport Badge from '../badges/Badge.vue'\nimport ExpirationBadge from '../badges/ExpirationBadge.vue'\nimport { translate } from 'rhg-vue-common'\n\nexport default {\n  name: 'ShortOfferCard',\n  components: {\n    IconLink,\n    Button,\n    Badge,\n    ExpirationBadge\n  },\n  props: {\n    badgeText: {\n      type: String\n    },\n    expiration: {\n      type: Object\n    },\n    title: {\n      type: String,\n      required: true\n    },\n    description: {\n      type: String\n    },\n    image: {\n      type: Object,\n      required: true\n    },\n    buttonPrimary: {\n      type: Object,\n      default: () => ({})\n    },\n    buttonSecondary: {\n      type: Object,\n      default: () => ({})\n    }\n  },\n  methods: {\n    translate,\n    handle (callback) {\n      typeof callback === 'function' && callback()\n    }\n  }\n}\n</script>\n\n<style lang=\"scss\" scoped>\n.offer-card {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  border-radius: .8rem;\n\n  @media (min-width: 768px) {\n    flex-direction: row;\n  }\n\n  &__main {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background: #fff;\n    width: 100%;\n    padding: 2.4rem;\n\n    @media (min-width: 768px) {\n      flex-direction: column;\n    }\n  }\n\n  &__badges {\n    @media (min-width: 768px) {\n      position: relative;\n      inset: auto;\n      margin-bottom: .5rem;\n    }\n  }\n\n  &__title {\n    font-style: normal;\n    font-weight: 300;\n    font-size: 2rem;\n    line-height: 2.6rem;\n    margin-bottom: .8rem;\n\n    @media (min-width: 768px) {\n      margin-bottom: 1.2rem;\n      font-size: 2.4rem;\n      line-height: 3rem;\n    }\n  }\n\n  &__description {\n    font-weight: 400;\n    font-size: 1.6rem;\n    margin-bottom: 0;\n  }\n\n  &__link {\n    text-transform: uppercase;\n    text-decoration: none;\n    margin-top: 1rem;\n\n    @media (min-width: 768px) {\n      max-width: 25rem;\n      height: auto;\n    }\n  }\n\n  &__img-container {\n    position: relative;\n    width: 100%;\n    height: 20rem;\n\n    @media (min-width: 768px) {\n      max-width: 25rem;\n      height: auto;\n    }\n  }\n\n  &__img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  &__book {\n    position: absolute;\n    bottom: 2rem;\n    right: 2rem;\n    z-index: 1;\n  }\n}\n\n</style>\n",".offer-card {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  border-radius: 0.8rem;\n}\n@media (min-width: 768px) {\n  .offer-card {\n    flex-direction: row;\n  }\n}\n.offer-card__main {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background: #fff;\n  width: 100%;\n  padding: 2.4rem;\n}\n@media (min-width: 768px) {\n  .offer-card__main {\n    flex-direction: column;\n  }\n}\n@media (min-width: 768px) {\n  .offer-card__badges {\n    position: relative;\n    inset: auto;\n    margin-bottom: 0.5rem;\n  }\n}\n.offer-card__title {\n  font-style: normal;\n  font-weight: 300;\n  font-size: 2rem;\n  line-height: 2.6rem;\n  margin-bottom: 0.8rem;\n}\n@media (min-width: 768px) {\n  .offer-card__title {\n    margin-bottom: 1.2rem;\n    font-size: 2.4rem;\n    line-height: 3rem;\n  }\n}\n.offer-card__description {\n  font-weight: 400;\n  font-size: 1.6rem;\n  margin-bottom: 0;\n}\n.offer-card__link {\n  text-transform: uppercase;\n  text-decoration: none;\n  margin-top: 1rem;\n}\n@media (min-width: 768px) {\n  .offer-card__link {\n    max-width: 25rem;\n    height: auto;\n  }\n}\n.offer-card__img-container {\n  position: relative;\n  width: 100%;\n  height: 20rem;\n}\n@media (min-width: 768px) {\n  .offer-card__img-container {\n    max-width: 25rem;\n    height: auto;\n  }\n}\n.offer-card__img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.offer-card__book {\n  position: absolute;\n  bottom: 2rem;\n  right: 2rem;\n  z-index: 1;\n}\n\n/*# sourceMappingURL=ShortOfferCard.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-18b6eb81";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export { __vue_component__$g as Badge, __vue_component__$f as Button, __vue_component__$d as Countdown, __vue_component__$c as ExpirationBadge, __vue_component__$a as GalleryModal, __vue_component__$7 as HotelCard, __vue_component__$5 as Icon, __vue_component__$6 as IconButton, __vue_component__$4 as Link, __vue_component__$3 as LinkLeftIcon, __vue_component__$2 as LinkRightIcon, __vue_component__$1 as OfferCard, __vue_component__$9 as Price, __vue_component__$e as SecondaryButton, __vue_component__ as ShortOfferCard, __vue_component__$8 as TripAdvisor };
